// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteCameraPortalData, DeleteCameraPortalErrors, DeleteCameraPortalResponses, DeleteCameraPublicData, DeleteCameraPublicErrors, DeleteCameraPublicResponses, DeleteConnectMeetingData, DeleteConnectMeetingErrors, DeleteConnectMeetingResponses, DeleteContactPortalData, DeleteContactPortalErrors, DeleteContactPortalResponses, DeleteContactPublicData, DeleteContactPublicErrors, DeleteContactPublicResponses, DeleteConversationTemplateContentData, DeleteConversationTemplateContentErrors, DeleteConversationTemplateContentResponses, DeleteConversationTemplateData, DeleteConversationTemplateErrors, DeleteConversationTemplateResponses, DeleteCrimeCodeRuleData, DeleteCrimeCodeRuleErrors, DeleteCrimeCodeRuleResponses, DeleteGeoDataFileData, DeleteGeoDataFileErrors, DeleteGeoDataFileProcessingRunData, DeleteGeoDataFileProcessingRunErrors, DeleteGeoDataFileProcessingRunResponses, DeleteGeoDataFileResponses, DeleteIntelImageMatchData, DeleteIntelImageMatchErrors, DeleteIntelImageMatchResponses, DeleteIntelMatchReportData, DeleteIntelMatchReportErrors, DeleteIntelMatchReportResponses, DeleteIntelSubmissionData, DeleteIntelSubmissionErrors, DeleteIntelSubmissionResponses, DeleteItemTypeOptionData, DeleteItemTypeOptionErrors, DeleteItemTypeOptionResponses, DeleteNotificationRuleData, DeleteNotificationRuleErrors, DeleteNotificationRuleResponses, DeleteOrgBrandingData, DeleteOrgBrandingErrors, DeleteOrgBrandingResponses, DeleteOrgData, DeleteOrgErrors, DeleteOrgResponses, DeleteOrgSurveyGroupData, DeleteOrgSurveyGroupErrors, DeleteOrgSurveyGroupResponses, DeleteOrgTemplatesData, DeleteOrgTemplatesErrors, DeleteOrgTemplatesResponses, DeletePermissionData, DeletePermissionErrors, DeletePermissionResponses, DeletePropertyPortalData, DeletePropertyPortalErrors, DeletePropertyPortalResponses, DeletePropertyPublicData, DeletePropertyPublicErrors, DeletePropertyPublicResponses, DeleteRegionData, DeleteRegionErrors, DeleteRegionResponses, DeleteSsoConnectionData, DeleteSsoConnectionErrors, DeleteSsoConnectionResponses, DeleteSubmissionCrimeCodeData, DeleteSubmissionCrimeCodeErrors, DeleteSubmissionCrimeCodeResponses, DeleteSubmissionPortalData, DeleteSubmissionPortalErrors, DeleteSubmissionPortalResponses, DeleteSubmissionPublicData, DeleteSubmissionPublicErrors, DeleteSubmissionPublicResponses, DeleteSubmissionViewingLeaveData, DeleteSubmissionViewingLeaveErrors, DeleteSubmissionViewingLeaveResponses, DeleteSurveyData, DeleteSurveyErrors, DeleteSurveyResponses, DeleteSurveyVersionDraftData, DeleteSurveyVersionDraftErrors, DeleteSurveyVersionDraftResponses, DeleteUserKvData, DeleteUserKvErrors, DeleteUserKvResponses, DeleteUserSurveyAccessData, DeleteUserSurveyAccessErrors, DeleteUserSurveyAccessResponses, DuplicateItemTypeOptionData, DuplicateItemTypeOptionErrors, DuplicateItemTypeOptionResponses, GetCheckStatusEligibleSubmissionsPublicData, GetCheckStatusEligibleSubmissionsPublicErrors, GetCheckStatusEligibleSubmissionsPublicResponses, GetCheckStatusSubmissionPublicData, GetCheckStatusSubmissionPublicErrors, GetCheckStatusSubmissionPublicResponses, GetCommunityPublicData, GetCommunityPublicErrors, GetCommunityPublicResponses, GetConnectAuditData, GetConnectAuditErrors, GetConnectAuditResponses, GetConnectAvailabilityData, GetConnectAvailabilityErrors, GetConnectAvailabilityPublicData, GetConnectAvailabilityPublicErrors, GetConnectAvailabilityPublicResponses, GetConnectAvailabilityResponses, GetConnectImagesData, GetConnectImagesErrors, GetConnectImagesResponses, GetConnectInvitationInfoData, GetConnectInvitationInfoErrors, GetConnectInvitationInfoResponses, GetConnectInvitationsData, GetConnectInvitationsErrors, GetConnectInvitationsResponses, GetConnectInvitationStatusData, GetConnectInvitationStatusErrors, GetConnectInvitationStatusResponses, GetConnectLocationsData, GetConnectLocationsErrors, GetConnectLocationsResponses, GetConnectMeetingData, GetConnectMeetingDialInData, GetConnectMeetingDialInErrors, GetConnectMeetingDialInResponses, GetConnectMeetingErrors, GetConnectMeetingJoinInfoData, GetConnectMeetingJoinInfoErrors, GetConnectMeetingJoinInfoResponses, GetConnectMeetingResponses, GetConnectOccurrenceData, GetConnectOccurrenceErrors, GetConnectOccurrenceLookupData, GetConnectOccurrenceLookupErrors, GetConnectOccurrenceLookupResponses, GetConnectOccurrenceResponses, GetConnectRecordingData, GetConnectRecordingErrors, GetConnectRecordingResponses, GetConversationAuditLogData, GetConversationAuditLogErrors, GetConversationAuditLogResponses, GetConversationClientData, GetConversationClientErrors, GetConversationClientResponses, GetConversationData, GetConversationErrors, GetConversationResponses, GetConversationTemplateData, GetConversationTemplateErrors, GetConversationTemplateResponses, GetCrimeCodeData, GetCrimeCodeErrors, GetCrimeCodeResponses, GetCrimeCodeRulesData, GetCrimeCodeRulesErrors, GetCrimeCodeRulesResponses, GetCrimeCodesData, GetCrimeCodesErrors, GetCrimeCodesResponses, GetDashboardData, GetDashboardErrors, GetDashboardResponses, GetDrugSubmissionAttachmentDescriptionPortalData, GetDrugSubmissionAttachmentDescriptionPortalErrors, GetDrugSubmissionAttachmentDescriptionPortalResponses, GetGeoDataFileData, GetGeoDataFileErrors, GetGeoDataFileProcessingRunData, GetGeoDataFileProcessingRunErrors, GetGeoDataFileProcessingRunResponses, GetGeoDataFileResponses, GetIntelMatchReportData, GetIntelMatchReportErrors, GetIntelMatchReportPdfData, GetIntelMatchReportPdfErrors, GetIntelMatchReportPdfResponses, GetIntelMatchReportResponses, GetItemTypeOptionData, GetItemTypeOptionErrors, GetItemTypeOptionResponses, GetLinterSchemaData, GetLinterSchemaErrors, GetLinterSchemaResponses, GetM2mClientData, GetM2mClientErrors, GetM2mClientResponses, GetM2mRecordDownloadData, GetM2mRecordDownloadErrors, GetM2mRecordDownloadResponses, GetModifyListPublicData, GetModifyListPublicErrors, GetModifyListPublicResponses, GetNewsletterMailingListData, GetNewsletterMailingListErrors, GetNewsletterMailingListResponses, GetOrgConfigPortalData, GetOrgConfigPortalErrors, GetOrgConfigPortalResponses, GetOrgConfigPublicData, GetOrgConfigPublicErrors, GetOrgConfigPublicResponses, GetOrgData, GetOrgDraftsData, GetOrgDraftsErrors, GetOrgDraftsResponses, GetOrgErrors, GetOrgLookupData, GetOrgLookupErrors, GetOrgLookupResponses, GetOrgResponses, GetOrgSurveyConfigPortalData, GetOrgSurveyConfigPortalErrors, GetOrgSurveyConfigPortalResponses, GetOrgSurveyGroupsData, GetOrgSurveyGroupsErrors, GetOrgSurveyGroupsResponses, GetOrgSurveysData, GetOrgSurveysErrors, GetOrgSurveysResponses, GetOrgSurveyVersionOverviewData, GetOrgSurveyVersionOverviewErrors, GetOrgSurveyVersionOverviewResponses, GetOrgTemplatesData, GetOrgTemplatesErrors, GetOrgTemplatesResponses, GetOrgUsersData, GetOrgUsersErrors, GetOrgUsersResponses, GetPartnerFilterOptionsData, GetPartnerFilterOptionsErrors, GetPartnerFilterOptionsResponses, GetPartnerOrgData, GetPartnerOrgErrors, GetPartnerOrgResponses, GetPartnerOrgRubiOrgData, GetPartnerOrgRubiOrgErrors, GetPartnerOrgRubiOrgResponses, GetPoliceServiceData, GetPoliceServiceErrors, GetPoliceServiceResponses, GetPropertyCamerasCheckPublicData, GetPropertyCamerasCheckPublicErrors, GetPropertyCamerasCheckPublicResponses, GetPropertyContactsCheckPublicData, GetPropertyContactsCheckPublicErrors, GetPropertyContactsCheckPublicResponses, GetPropertyLocationCheckPublicData, GetPropertyLocationCheckPublicErrors, GetPropertyLocationCheckPublicResponses, GetPropertyPortalData, GetPropertyPortalErrors, GetPropertyPortalResponses, GetPropertyPublicData, GetPropertyPublicErrors, GetPropertyPublicResponses, GetRegionActiveAreaData, GetRegionActiveAreaErrors, GetRegionActiveAreaResponses, GetRegionAreaData, GetRegionAreaErrors, GetRegionAreaResponses, GetRegionData, GetRegionErrors, GetRegionMapData, GetRegionMapErrors, GetRegionMapResponses, GetRegionResponses, GetReportSuggestionData, GetReportSuggestionErrors, GetReportSuggestionResponses, GetRmsExportErrorData, GetRmsExportErrorErrors, GetRmsExportErrorResponses, GetSsoJitData, GetSsoJitErrors, GetSsoJitResponses, GetSubmissionAssignableUsersData, GetSubmissionAssignableUsersErrors, GetSubmissionAssignableUsersResponses, GetSubmissionAttachmentDescriptionPortalData, GetSubmissionAttachmentDescriptionPortalErrors, GetSubmissionAttachmentDescriptionPortalResponses, GetSubmissionAttachmentDescriptionPublicData, GetSubmissionAttachmentDescriptionPublicErrors, GetSubmissionAttachmentDescriptionPublicResponses, GetSubmissionAuditLogPortalData, GetSubmissionAuditLogPortalErrors, GetSubmissionAuditLogPortalResponses, GetSubmissionCrimeCodesData, GetSubmissionCrimeCodesErrors, GetSubmissionCrimeCodesResponses, GetSubmissionModifyListPublicData, GetSubmissionModifyListPublicErrors, GetSubmissionModifyListPublicResponses, GetSubmissionPartnerData, GetSubmissionPartnerErrors, GetSubmissionPartnerPdfData, GetSubmissionPartnerPdfErrors, GetSubmissionPartnerPdfResponses, GetSubmissionPartnerResponses, GetSubmissionPdfPortalData, GetSubmissionPdfPortalErrors, GetSubmissionPdfPortalResponses, GetSubmissionPdfPublicData, GetSubmissionPdfPublicErrors, GetSubmissionPdfPublicResponses, GetSubmissionPortalData, GetSubmissionPortalErrors, GetSubmissionPortalResponses, GetSubmissionPublicData, GetSubmissionPublicErrors, GetSubmissionPublicResponses, GetSubmissionRecommendedSurveyClassesPublicData, GetSubmissionRecommendedSurveyClassesPublicErrors, GetSubmissionRecommendedSurveyClassesPublicResponses, GetSubmissionSupplementalCarryOverPublicData, GetSubmissionSupplementalCarryOverPublicErrors, GetSubmissionSupplementalCarryOverPublicResponses, GetSubmissionSynopsisPortalData, GetSubmissionSynopsisPortalErrors, GetSubmissionSynopsisPortalResponses, GetSubmissionVersionDiffData, GetSubmissionVersionDiffErrors, GetSubmissionVersionDiffResponses, GetSubmissionViewersData, GetSubmissionViewersErrors, GetSubmissionViewersResponses, GetSubmissionXmlGenerationTestPortalData, GetSubmissionXmlGenerationTestPortalErrors, GetSubmissionXmlGenerationTestPortalResponses, GetSubregionAreaData, GetSubregionAreaErrors, GetSubregionAreaResponses, GetSubregionData, GetSubregionErrors, GetSubregionResponses, GetSurveyConfigData, GetSurveyConfigErrors, GetSurveyConfigResponses, GetSurveyCurrentVersionData, GetSurveyCurrentVersionErrors, GetSurveyCurrentVersionResponses, GetSurveyData, GetSurveyErrors, GetSurveyNamesData, GetSurveyNamesErrors, GetSurveyNamesResponses, GetSurveyResponses, GetSurveyTranslationsData, GetSurveyTranslationsErrors, GetSurveyTranslationsResponses, GetSurveyVersionCompareData, GetSurveyVersionCompareErrors, GetSurveyVersionCompareResponses, GetSurveyVersionData, GetSurveyVersionDraftData, GetSurveyVersionDraftErrors, GetSurveyVersionDraftResponses, GetSurveyVersionErrors, GetSurveyVersionResponses, GetUserMeData, GetUserMeErrors, GetUserMeResponses, GetUserMeRsData, GetUserMeRsErrors, GetUserMeRsResponses, GetUserSurveyAccessData, GetUserSurveyAccessErrors, GetUserSurveyAccessResponses, ImportSubmissionData2, ImportSubmissionErrors, ImportSubmissionResponses, ListCameraData, ListCameraErrors, ListCameraResponses, ListCommunityPublicData, ListCommunityPublicErrors, ListCommunityPublicResponses, ListConnectBookingData, ListConnectBookingErrors, ListConnectBookingResponses, ListConnectMeetingData, ListConnectMeetingErrors, ListConnectMeetingResponses, ListConnectOccurrenceData, ListConnectOccurrenceErrors, ListConnectOccurrenceResponses, ListConnectRecordingData, ListConnectRecordingErrors, ListConnectRecordingResponses, ListConversationData, ListConversationErrors, ListConversationResponses, ListConversationTemplateData, ListConversationTemplateErrors, ListConversationTemplateResponses, ListGeoDataFileData, ListGeoDataFileErrors, ListGeoDataFileProcessingRunData, ListGeoDataFileProcessingRunErrors, ListGeoDataFileProcessingRunResponses, ListGeoDataFileResponses, ListIntelImageMatchByAttachmentData, ListIntelImageMatchByAttachmentErrors, ListIntelImageMatchByAttachmentResponses, ListIntelImageMatchBySubmissionData, ListIntelImageMatchBySubmissionErrors, ListIntelImageMatchBySubmissionResponses, ListIntelMatchReportData, ListIntelMatchReportErrors, ListIntelMatchReportResponses, ListIntelOrgTitlesData, ListIntelOrgTitlesErrors, ListIntelOrgTitlesResponses, ListM2mClientData, ListM2mClientErrors, ListM2mClientResponses, ListMessagingUserData, ListMessagingUserErrors, ListMessagingUserResponses, ListMyIntelSubmissionData, ListMyIntelSubmissionErrors, ListMyIntelSubmissionResponses, ListNotificationRuleData, ListNotificationRuleErrors, ListNotificationRuleResponses, ListOrgData, ListOrgErrors, ListOrgItemTypeOptionsData, ListOrgItemTypeOptionsErrors, ListOrgItemTypeOptionsLegacyData, ListOrgItemTypeOptionsLegacyErrors, ListOrgItemTypeOptionsLegacyResponses, ListOrgItemTypeOptionsResponses, ListOrgResponses, ListOrgSubmissionData, ListOrgSubmissionErrors, ListOrgSubmissionResponses, ListPartnerOrgData, ListPartnerOrgErrors, ListPartnerOrgResponses, ListPermissionData, ListPermissionErrors, ListPermissionResponses, ListPermissionUserData, ListPermissionUserErrors, ListPermissionUserResponses, ListRegionData, ListRegionErrors, ListRegionResponses, ListRegistrySubmissionPublicData, ListRegistrySubmissionPublicErrors, ListRegistrySubmissionPublicResponses, ListRmsExportErrorData, ListRmsExportErrorErrors, ListRmsExportErrorResponses, ListScheduledJobData, ListScheduledJobErrors, ListScheduledJobResponses, ListSharedItemTypeOptionsData, ListSharedItemTypeOptionsErrors, ListSharedItemTypeOptionsResponses, ListSsoConnectionsData, ListSsoConnectionsErrors, ListSsoConnectionsResponses, ListSubmissionAnalyticsData, ListSubmissionAnalyticsErrors, ListSubmissionAnalyticsResponses, ListSubmissionPartnerData, ListSubmissionPartnerErrors, ListSubmissionPartnerResponses, ListSubmissionRegistryData, ListSubmissionRegistryErrors, ListSubmissionRegistryResponses, ListSubmissionReportData, ListSubmissionReportErrors, ListSubmissionReportResponses, ListSubmissionRequestData, ListSubmissionRequestErrors, ListSubmissionRequestResponses, ListSubregionData, ListSubregionErrors, ListSubregionResponses, ListSurveyVersionsData, ListSurveyVersionsErrors, ListSurveyVersionsResponses, PatchCallLogData, PatchCallLogErrors, PatchCallLogResponses, PatchCameraPortalData, PatchCameraPortalErrors, PatchCameraPortalResponses, PatchCameraPublicData, PatchCameraPublicErrors, PatchCameraPublicResponses, PatchConnectBookingData, PatchConnectBookingErrors, PatchConnectBookingResponses, PatchConnectMeetingData, PatchConnectMeetingErrors, PatchConnectMeetingResponses, PatchContactPortalData, PatchContactPortalErrors, PatchContactPortalResponses, PatchContactPublicData, PatchContactPublicErrors, PatchContactPublicResponses, PatchConversationClientData, PatchConversationClientErrors, PatchConversationClientResponses, PatchConversationData, PatchConversationErrors, PatchConversationResponses, PatchConversationTemplateData, PatchConversationTemplateErrors, PatchConversationTemplateResponses, PatchCrimeCodeData, PatchCrimeCodeErrors, PatchCrimeCodeResponses, PatchCrimeCodeRuleData, PatchCrimeCodeRuleErrors, PatchCrimeCodeRuleResponses, PatchIntelMatchReportData, PatchIntelMatchReportErrors, PatchIntelMatchReportResponses, PatchLinterSchemaData, PatchLinterSchemaErrors, PatchLinterSchemaResponses, PatchNotificationRuleData, PatchNotificationRuleErrors, PatchNotificationRuleResponses, PatchOrgAdminData, PatchOrgAdminErrors, PatchOrgAdminResponses, PatchOrgConfigAdminData, PatchOrgConfigAdminErrors, PatchOrgConfigAdminResponses, PatchOrgConfigData, PatchOrgConfigErrors, PatchOrgConfigResponses, PatchOrgSurveyGroupData, PatchOrgSurveyGroupErrors, PatchOrgSurveyGroupResponses, PatchOrgTemplatesData, PatchOrgTemplatesErrors, PatchOrgTemplatesResponses, PatchPartnerOrgData, PatchPartnerOrgErrors, PatchPartnerOrgResponses, PatchPoliceServiceData, PatchPoliceServiceErrors, PatchPoliceServiceResponses, PatchPropertyPortalData, PatchPropertyPortalErrors, PatchPropertyPortalResponses, PatchPropertyPublicData, PatchPropertyPublicErrors, PatchPropertyPublicResponses, PatchPublicAccountData, PatchPublicAccountErrors, PatchPublicAccountResponses, PatchRegionData, PatchRegionErrors, PatchRegionResponses, PatchRmsExportErrorSubmissionData, PatchRmsExportErrorSubmissionErrors, PatchRmsExportErrorSubmissionResponses, PatchSsoSamlConnectionData, PatchSsoSamlConnectionErrors, PatchSsoSamlConnectionResponses, PatchSubmissionAttachmentData, PatchSubmissionAttachmentErrors, PatchSubmissionAttachmentResponses, PatchSubmissionPortalData, PatchSubmissionPortalErrors, PatchSubmissionPortalResponses, PatchSubmissionPublicData, PatchSubmissionPublicErrors, PatchSubmissionPublicResponses, PatchSubmissionViewingEditingData, PatchSubmissionViewingEditingErrors, PatchSubmissionViewingEditingResponses, PatchSubregionData, PatchSubregionErrors, PatchSubregionResponses, PatchSurveyVersionDraftData, PatchSurveyVersionDraftErrors, PatchSurveyVersionDraftResponses, PatchTranslateReportToEnglishData, PatchTranslateReportToEnglishErrors, PatchTranslateReportToEnglishResponses, PostAuthAddPhoneRsData, PostAuthAddPhoneRsErrors, PostAuthAddPhoneRsResponses, PostAuthLoginRsData, PostAuthLoginRsErrors, PostAuthLoginRsResponses, PostAuthLogoutRsData, PostAuthLogoutRsErrors, PostAuthLogoutRsResponses, PostAuthResendCodeRsData, PostAuthResendCodeRsErrors, PostAuthResendCodeRsResponses, PostAuthVerifyOtpRsData, PostAuthVerifyOtpRsErrors, PostAuthVerifyOtpRsResponses, PostBatchVectorizeAttachmentsData, PostBatchVectorizeAttachmentsErrors, PostBatchVectorizeAttachmentsResponses, PostBulkDeployData, PostBulkDeployErrors, PostBulkDeployResponses, PostBulkEditApplyData, PostBulkEditApplyErrors, PostBulkEditApplyResponses, PostBulkEditPreviewData, PostBulkEditPreviewErrors, PostBulkEditPreviewResponses, PostBulkEditSearchData, PostBulkEditSearchErrors, PostBulkEditSearchResponses, PostChatkitSessionData, PostChatkitSessionErrors, PostChatkitSessionResponses, PostCheckStatusRequestPublicData, PostCheckStatusRequestPublicErrors, PostCheckStatusRequestPublicResponses, PostCheckStatusVerifyPublicData, PostCheckStatusVerifyPublicErrors, PostCheckStatusVerifyPublicResponses, PostConnectBookingPublicData, PostConnectBookingPublicErrors, PostConnectBookingPublicResponses, PostConnectImageData, PostConnectImageErrors, PostConnectImageResponses, PostConnectInvitationAcknowledgeData, PostConnectInvitationAcknowledgeErrors, PostConnectInvitationAcknowledgeResponses, PostConnectInvitationCopiedData, PostConnectInvitationCopiedErrors, PostConnectInvitationCopiedResponses, PostConnectInvitationData, PostConnectInvitationDecisionData, PostConnectInvitationDecisionErrors, PostConnectInvitationDecisionResponses, PostConnectInvitationErrors, PostConnectInvitationInterruptionData, PostConnectInvitationInterruptionErrors, PostConnectInvitationInterruptionResponses, PostConnectInvitationJoinData, PostConnectInvitationJoinErrors, PostConnectInvitationJoinResponses, PostConnectInvitationLeaveData, PostConnectInvitationLeaveErrors, PostConnectInvitationLeaveResponses, PostConnectInvitationLocationData, PostConnectInvitationLocationErrors, PostConnectInvitationLocationResponses, PostConnectInvitationPermissionsData, PostConnectInvitationPermissionsErrors, PostConnectInvitationPermissionsResponses, PostConnectInvitationRequestPauseCancelData, PostConnectInvitationRequestPauseCancelErrors, PostConnectInvitationRequestPauseCancelResponses, PostConnectInvitationRequestPauseData, PostConnectInvitationRequestPauseErrors, PostConnectInvitationRequestPauseResponses, PostConnectInvitationResponses, PostConnectInvitationSendData, PostConnectInvitationSendErrors, PostConnectInvitationSendResponses, PostConnectMeetingData, PostConnectMeetingDialOutData, PostConnectMeetingDialOutErrors, PostConnectMeetingDialOutResponses, PostConnectMeetingEndData, PostConnectMeetingEndErrors, PostConnectMeetingEndResponses, PostConnectMeetingErrors, PostConnectMeetingJoinPublicData, PostConnectMeetingJoinPublicErrors, PostConnectMeetingJoinPublicResponses, PostConnectMeetingPauseData, PostConnectMeetingPauseErrors, PostConnectMeetingPauseResponses, PostConnectMeetingResponses, PostConnectMeetingTokenData, PostConnectMeetingTokenErrors, PostConnectMeetingTokenResponses, PostConnectOccurrenceData, PostConnectOccurrenceErrors, PostConnectOccurrenceResponses, PostConnectParticipantCameraRequestData, PostConnectParticipantCameraRequestErrors, PostConnectParticipantCameraRequestResponses, PostConnectParticipantMediaData, PostConnectParticipantMediaErrors, PostConnectParticipantMediaResponses, PostConnectRecordingExportData, PostConnectRecordingExportErrors, PostConnectRecordingExportResponses, PostConversationData, PostConversationErrors, PostConversationOutboundMessageData, PostConversationOutboundMessageErrors, PostConversationOutboundMessageResponses, PostConversationResponses, PostConversationTemplateData, PostConversationTemplateErrors, PostConversationTemplateResponses, PostConversationTemplateTranslateData, PostConversationTemplateTranslateErrors, PostConversationTemplateTranslateResponses, PostCopyOrganizationFormConfigData, PostCopyOrganizationFormConfigErrors, PostCopyOrganizationFormConfigResponses, PostCreateSingleSubmissionModificationTokenData, PostCreateSingleSubmissionModificationTokenErrors, PostCreateSingleSubmissionModificationTokenResponses, PostCrimeCodeArchiveData, PostCrimeCodeArchiveErrors, PostCrimeCodeArchiveResponses, PostCrimeCodeData, PostCrimeCodeErrors, PostCrimeCodeResponses, PostCrimeCodeRuleData, PostCrimeCodeRuleErrors, PostCrimeCodeRuleResponses, PostDeactivateSurveyConfigData, PostDeactivateSurveyConfigErrors, PostDeactivateSurveyConfigResponses, PostEmailVerificationOtpAuthenticateData, PostEmailVerificationOtpAuthenticateErrors, PostEmailVerificationOtpAuthenticateResponses, PostGenerateNarrativeFromSurveyJsonData, PostGenerateNarrativeFromSurveyJsonErrors, PostGenerateNarrativeFromSurveyJsonResponses, PostGeoDataFileCompleteData, PostGeoDataFileCompleteErrors, PostGeoDataFileCompleteResponses, PostGeoDataFileData, PostGeoDataFileErrors, PostGeoDataFileProcessData, PostGeoDataFileProcessErrors, PostGeoDataFileProcessResponses, PostGeoDataFileResponses, PostImageSearchPortalData, PostImageSearchPortalErrors, PostImageSearchPortalResponses, PostIntelImageMatchData, PostIntelImageMatchErrors, PostIntelImageMatchResponses, PostIntelMatchReportData, PostIntelMatchReportErrors, PostIntelMatchReportResponses, PostItemTypeOptionBulkRecaseData, PostItemTypeOptionBulkRecaseErrors, PostItemTypeOptionBulkRecaseResponses, PostItemTypeOptionConvertV2Data, PostItemTypeOptionConvertV2Errors, PostItemTypeOptionConvertV2Responses, PostItemTypeOptionData, PostItemTypeOptionErrors, PostItemTypeOptionRecasePreviewData, PostItemTypeOptionRecasePreviewErrors, PostItemTypeOptionRecasePreviewResponses, PostItemTypeOptionResponses, PostLoginData, PostLoginErrors, PostLoginResponses, PostLogoutData, PostLogoutErrors, PostLogoutResponses, PostM2mClientData, PostM2mClientErrors, PostM2mClientResponses, PostM2mClientRotateCancelData, PostM2mClientRotateCancelErrors, PostM2mClientRotateCancelResponses, PostM2mClientRotateData, PostM2mClientRotateErrors, PostM2mClientRotateResponses, PostM2mClientRotateStartData, PostM2mClientRotateStartErrors, PostM2mClientRotateStartResponses, PostMfaEmailSendData, PostMfaEmailSendErrors, PostMfaEmailSendResponses, PostMfaSmsSendData, PostMfaSmsSendErrors, PostMfaSmsSendResponses, PostMfaVerifyData, PostMfaVerifyErrors, PostMfaVerifyResponses, PostModifyRequestPublicData, PostModifyRequestPublicErrors, PostModifyRequestPublicResponses, PostNarrativeFormCompletionPublicData, PostNarrativeFormCompletionPublicErrors, PostNarrativeFormCompletionPublicResponses, PostNotificationRuleData, PostNotificationRuleErrors, PostNotificationRuleResponses, PostOauthCallbackPublicData, PostOauthCallbackPublicErrors, PostOauthCallbackPublicResponses, PostOrgBootstrapData, PostOrgBootstrapErrors, PostOrgBootstrapResponses, PostOrgData, PostOrgErrors, PostOrgImportMark43CrimeCodesData, PostOrgImportMark43CrimeCodesErrors, PostOrgImportMark43CrimeCodesResponses, PostOrgImportMark43ItemListsData, PostOrgImportMark43ItemListsErrors, PostOrgImportMark43ItemListsResponses, PostOrgResponses, PostOrgSurveyGroupData, PostOrgSurveyGroupErrors, PostOrgSurveyGroupResponses, PostPartnerOrgBootstrapData, PostPartnerOrgBootstrapErrors, PostPartnerOrgBootstrapResponses, PostPasswordResetData, PostPasswordResetErrors, PostPasswordResetResponses, PostPasswordResetStartData, PostPasswordResetStartErrors, PostPasswordResetStartResponses, PostPermissionAddUserData, PostPermissionAddUserErrors, PostPermissionAddUserResponses, PostPermissionRemoveUserData, PostPermissionRemoveUserErrors, PostPermissionRemoveUserResponses, PostPropertySubmitPortalData, PostPropertySubmitPortalErrors, PostPropertySubmitPortalResponses, PostPropertySubmitPublicData, PostPropertySubmitPublicErrors, PostPropertySubmitPublicResponses, PostRegionData, PostRegionErrors, PostRegionResponses, PostResetPasswordByExistingPasswordData, PostResetPasswordByExistingPasswordErrors, PostResetPasswordByExistingPasswordResponses, PostRmsExportErrorReexportData, PostRmsExportErrorReexportErrors, PostRmsExportErrorReexportResponses, PostRmsExportErrorTestExportData, PostRmsExportErrorTestExportErrors, PostRmsExportErrorTestExportResponses, PostSendModifyRemoveRegistryTokenEmailData, PostSendModifyRemoveRegistryTokenEmailErrors, PostSendModifyRemoveRegistryTokenEmailResponses, PostSignupData, PostSignupErrors, PostSignupResponses, PostSmsData, PostSmsErrors, PostSsoSamlConnectionData, PostSsoSamlConnectionErrors, PostSsoSamlConnectionResponses, PostSubmissionAttachmentExportStatusData, PostSubmissionAttachmentExportStatusErrors, PostSubmissionAttachmentExportStatusResponses, PostSubmissionAttachmentOpenaiPdfAnalysisData, PostSubmissionAttachmentOpenaiPdfAnalysisErrors, PostSubmissionAttachmentOpenaiPdfAnalysisResponses, PostSubmissionAttachmentOpenaiPdfAnalysisResponsesData, PostSubmissionAttachmentOpenaiPdfAnalysisResponsesErrors, PostSubmissionAttachmentOpenaiPdfAnalysisResponsesResponses, PostSubmissionAttachmentPortalData, PostSubmissionAttachmentPortalErrors, PostSubmissionAttachmentPortalResponses, PostSubmissionAttachmentPublicData, PostSubmissionAttachmentPublicErrors, PostSubmissionAttachmentPublicResponses, PostSubmissionAttachmentReleaseOrderAnalysisPublicData, PostSubmissionAttachmentReleaseOrderAnalysisPublicErrors, PostSubmissionAttachmentReleaseOrderAnalysisPublicResponses, PostSubmissionAttachmentThumbnailPortalData, PostSubmissionAttachmentThumbnailPortalErrors, PostSubmissionAttachmentThumbnailPortalResponses, PostSubmissionAttachmentThumbnailPublicData, PostSubmissionAttachmentThumbnailPublicErrors, PostSubmissionAttachmentThumbnailPublicResponses, PostSubmissionAttachmentVectorPortalData, PostSubmissionAttachmentVectorPortalResponses, PostSubmissionAttachmentVectorPublicData, PostSubmissionAttachmentVectorPublicResponses, PostSubmissionBreachStatementPublicData, PostSubmissionBreachStatementPublicErrors, PostSubmissionBreachStatementPublicResponses, PostSubmissionChoiceMatchPublicData, PostSubmissionChoiceMatchPublicErrors, PostSubmissionChoiceMatchPublicResponses, PostSubmissionClearExportPortalData, PostSubmissionClearExportPortalErrors, PostSubmissionClearExportPortalResponses, PostSubmissionConversationData, PostSubmissionConversationErrors, PostSubmissionConversationResponses, PostSubmissionCreateBulletinUrlData, PostSubmissionCreateBulletinUrlErrors, PostSubmissionCreateBulletinUrlResponses, PostSubmissionCrimeCodeData, PostSubmissionCrimeCodeErrors, PostSubmissionCrimeCodeResponses, PostSubmissionDetectLanguagePublicData, PostSubmissionDetectLanguagePublicErrors, PostSubmissionDetectLanguagePublicResponses, PostSubmissionExportEvidencePortalData, PostSubmissionExportEvidencePortalErrors, PostSubmissionExportEvidencePortalResponses, PostSubmissionExportMark43PortalData, PostSubmissionExportMark43PortalErrors, PostSubmissionExportMark43PortalResponses, PostSubmissionGenerateIncidentPortalData, PostSubmissionGenerateIncidentPortalErrors, PostSubmissionGenerateIncidentPortalResponses, PostSubmissionGenerateThumbnailsPortalData, PostSubmissionGenerateThumbnailsPortalErrors, PostSubmissionGenerateThumbnailsPortalResponses, PostSubmissionModifyRequestPublicData, PostSubmissionModifyRequestPublicErrors, PostSubmissionModifyRequestPublicResponses, PostSubmissionOneDayModificationTokenData, PostSubmissionOneDayModificationTokenErrors, PostSubmissionOneDayModificationTokenResponses, PostSubmissionScheduleModificationRequestedJobsData, PostSubmissionScheduleModificationRequestedJobsErrors, PostSubmissionScheduleModificationRequestedJobsResponses, PostSubmissionSendInitialLinkData, PostSubmissionSendInitialLinkErrors, PostSubmissionSendInitialLinkResponses, PostSubmissionShareData, PostSubmissionShareErrors, PostSubmissionShareResponses, PostSubmissionStatusPortalData, PostSubmissionStatusPortalErrors, PostSubmissionStatusPortalResponses, PostSubmissionStatusPublicData, PostSubmissionStatusPublicErrors, PostSubmissionStatusPublicResponses, PostSubmissionSupplementalStatusData, PostSubmissionSupplementalStatusErrors, PostSubmissionSupplementalStatusResponses, PostSubmissionSynopsisVerifiedPortalData, PostSubmissionSynopsisVerifiedPortalErrors, PostSubmissionSynopsisVerifiedPortalResponses, PostSubmissionUpdateNotificationPortalData, PostSubmissionUpdateNotificationPortalErrors, PostSubmissionUpdateNotificationPortalResponses, PostSubmissionValidateOrSendModificationLinkData, PostSubmissionValidateOrSendModificationLinkErrors, PostSubmissionValidateOrSendModificationLinkResponses, PostSubmissionValidateOrSendRecoveryLinkData, PostSubmissionValidateOrSendRecoveryLinkErrors, PostSubmissionValidateOrSendRecoveryLinkResponses, PostSubmissionViewingJoinData, PostSubmissionViewingJoinErrors, PostSubmissionViewingJoinResponses, PostSurveyCondensedData, PostSurveyCondensedErrors, PostSurveyCondensedResponses, PostSurveyCreateData, PostSurveyCreateErrors, PostSurveyCreateResponses, PostSurveyExportData, PostSurveyExportErrors, PostSurveyExportResponses, PostSurveyVersionDeployData, PostSurveyVersionDeployErrors, PostSurveyVersionDeployResponses, PostSurveyVersionRollbackData, PostSurveyVersionRollbackErrors, PostSurveyVersionRollbackResponses, PostTranslateAllNameDescriptionSurveyFieldsData, PostTranslateAllNameDescriptionSurveyFieldsErrors, PostTranslateAllNameDescriptionSurveyFieldsResponses, PostTriggerSendManyRubiUsersData, PostTriggerSendManyRubiUsersErrors, PostTriggerSendManyRubiUsersResponses, PostTriggerSendRubiOrgData, PostTriggerSendRubiOrgErrors, PostTriggerSendRubiOrgResponses, PostTriggerSendRubiUserData, PostTriggerSendRubiUserErrors, PostTriggerSendRubiUserResponses, PostUpdateManagedOnlineReportingSurveyTemplatesData, PostUpdateManagedOnlineReportingSurveyTemplatesErrors, PostUpdateManagedOnlineReportingSurveyTemplatesResponses, PostWebhookLivekitEgressData, PostWebhookLivekitEgressErrors, PostWebhookLivekitEgressResponses, PostWebhookRubiOrgData, PostWebhookRubiOrgErrors, PostWebhookRubiOrgResponses, PostWebhookRubiUserData, PostWebhookRubiUserErrors, PostWebhookRubiUserResponses, PostWebhookTwilioDeliveryStatusData, PostWebhookTwilioDeliveryStatusErrors, PostWebhookTwilioDeliveryStatusResponses, PostWebhookTwilioInboundMessageData, PostWebhookTwilioInboundMessageErrors, PostWebhookTwilioInboundMessageResponses, PutCallLogData, PutCallLogErrors, PutCallLogResponses, PutCameraPortalData, PutCameraPortalErrors, PutCameraPortalResponses, PutCameraPublicData, PutCameraPublicErrors, PutCameraPublicResponses, PutConnectAvailabilityData, PutConnectAvailabilityErrors, PutConnectAvailabilityResponses, PutContactPortalData, PutContactPortalErrors, PutContactPortalResponses, PutContactPublicData, PutContactPublicErrors, PutContactPublicResponses, PutItemTypeOptionData, PutItemTypeOptionErrors, PutItemTypeOptionResponses, PutM2mClientData, PutM2mClientErrors, PutM2mClientResponses, PutOrgBrandingData, PutOrgBrandingErrors, PutOrgBrandingResponses, PutOrgData, PutOrgErrors, PutOrgResponses, PutOrgTemplatesData, PutOrgTemplatesErrors, PutOrgTemplatesResponses, PutPermissionData, PutPermissionErrors, PutPermissionResponses, PutPropertyPortalData, PutPropertyPortalErrors, PutPropertyPortalResponses, PutPropertyPublicData, PutPropertyPublicErrors, PutPropertyPublicResponses, PutSsoConnectionJitData, PutSsoConnectionJitErrors, PutSsoConnectionJitResponses, PutSubmissionPortalData, PutSubmissionPortalErrors, PutSubmissionPortalResponses, PutSubmissionPublicData, PutSubmissionPublicErrors, PutSubmissionPublicResponses, PutSurveyData, PutSurveyErrors, PutSurveyGroupMembershipsData, PutSurveyGroupMembershipsErrors, PutSurveyGroupMembershipsResponses, PutSurveyResponses, PutUserCrData, PutUserCrErrors, PutUserCrResponses, PutUserKvData, PutUserKvErrors, PutUserKvResponses, PutUserRegistryData, PutUserRegistryErrors, PutUserRegistryResponses, PutUserRv2Data, PutUserRv2Errors, PutUserRv2Responses, PutUserSurveyAccessData, PutUserSurveyAccessErrors, PutUserSurveyAccessResponses, ResubscribeToDraftReminderData, ResubscribeToDraftReminderErrors, ResubscribeToDraftReminderResponses, SendReferralLinkData, SendReferralLinkErrors, SendReferralLinkResponses, UnsubscribeFromDraftReminderData, UnsubscribeFromDraftReminderErrors, UnsubscribeFromDraftReminderResponses, UpdateSurveyData, UpdateSurveyErrors, UpdateSurveyResponses, UpdateUserMeData, UpdateUserMeErrors, UpdateUserMeResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const deleteOrgBranding = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgBrandingData, ThrowOnError>): RequestResult<DeleteOrgBrandingResponses, DeleteOrgBrandingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgBrandingResponses, DeleteOrgBrandingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/admin/org/{org_id}/branding/{kind}',
    ...options
});

export const putOrgBranding = <ThrowOnError extends boolean = false>(options: Options<PutOrgBrandingData, ThrowOnError>): RequestResult<PutOrgBrandingResponses, PutOrgBrandingErrors, ThrowOnError> => (options.client ?? client).put<PutOrgBrandingResponses, PutOrgBrandingErrors, ThrowOnError>({
    bodySerializer: null,
    responseType: 'json',
    url: '/admin/org/{org_id}/branding/{kind}',
    ...options,
    headers: {
        'Content-Type': 'application/octet-stream',
        ...options.headers
    }
});

export const listSubmissionAnalytics = <ThrowOnError extends boolean = false>(options?: Options<ListSubmissionAnalyticsData, ThrowOnError>): RequestResult<ListSubmissionAnalyticsResponses, ListSubmissionAnalyticsErrors, ThrowOnError> => (options?.client ?? client).get<ListSubmissionAnalyticsResponses, ListSubmissionAnalyticsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/analytics/submission',
    ...options
});

export const postEmailVerificationOtpAuthenticate = <ThrowOnError extends boolean = false>(options: Options<PostEmailVerificationOtpAuthenticateData, ThrowOnError>): RequestResult<PostEmailVerificationOtpAuthenticateResponses, PostEmailVerificationOtpAuthenticateErrors, ThrowOnError> => (options.client ?? client).post<PostEmailVerificationOtpAuthenticateResponses, PostEmailVerificationOtpAuthenticateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/email_verification/otp/authenticate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postLogin = <ThrowOnError extends boolean = false>(options: Options<PostLoginData, ThrowOnError>): RequestResult<PostLoginResponses, PostLoginErrors, ThrowOnError> => (options.client ?? client).post<PostLoginResponses, PostLoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout the current user
 *
 * This endpoint invalidates the current session and clears the authentication cookie.
 * After calling this endpoint, the user will need to authenticate again.
 */
export const postLogout = <ThrowOnError extends boolean = false>(options?: Options<PostLogoutData, ThrowOnError>): RequestResult<PostLogoutResponses, PostLogoutErrors, ThrowOnError> => (options?.client ?? client).post<PostLogoutResponses, PostLogoutErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/logout',
    ...options
});

export const postMfaEmailSend = <ThrowOnError extends boolean = false>(options: Options<PostMfaEmailSendData, ThrowOnError>): RequestResult<PostMfaEmailSendResponses, PostMfaEmailSendErrors, ThrowOnError> => (options.client ?? client).post<PostMfaEmailSendResponses, PostMfaEmailSendErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/mfa/email/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMfaSmsSend = <ThrowOnError extends boolean = false>(options: Options<PostMfaSmsSendData, ThrowOnError>): RequestResult<PostMfaSmsSendResponses, PostMfaSmsSendErrors, ThrowOnError> => (options.client ?? client).post<PostMfaSmsSendResponses, PostMfaSmsSendErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/mfa/sms/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMfaVerify = <ThrowOnError extends boolean = false>(options: Options<PostMfaVerifyData, ThrowOnError>): RequestResult<PostMfaVerifyResponses, PostMfaVerifyErrors, ThrowOnError> => (options.client ?? client).post<PostMfaVerifyResponses, PostMfaVerifyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/mfa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle OAuth callback from Stytch
 *
 * This endpoint receives the token from Stytch after OAuth authentication
 * and validates it with the Stytch API. It then creates or finds the user
 * in the database and returns session information.
 */
export const postOauthCallbackPublic = <ThrowOnError extends boolean = false>(options: Options<PostOauthCallbackPublicData, ThrowOnError>): RequestResult<PostOauthCallbackPublicResponses, PostOauthCallbackPublicErrors, ThrowOnError> => (options.client ?? client).post<PostOauthCallbackPublicResponses, PostOauthCallbackPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/oauth/callback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postPasswordReset = <ThrowOnError extends boolean = false>(options: Options<PostPasswordResetData, ThrowOnError>): RequestResult<PostPasswordResetResponses, PostPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<PostPasswordResetResponses, PostPasswordResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/password/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postResetPasswordByExistingPassword = <ThrowOnError extends boolean = false>(options: Options<PostResetPasswordByExistingPasswordData, ThrowOnError>): RequestResult<PostResetPasswordByExistingPasswordResponses, PostResetPasswordByExistingPasswordErrors, ThrowOnError> => (options.client ?? client).post<PostResetPasswordByExistingPasswordResponses, PostResetPasswordByExistingPasswordErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/password/reset-by-existing-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postPasswordResetStart = <ThrowOnError extends boolean = false>(options: Options<PostPasswordResetStartData, ThrowOnError>): RequestResult<PostPasswordResetStartResponses, PostPasswordResetStartErrors, ThrowOnError> => (options.client ?? client).post<PostPasswordResetStartResponses, PostPasswordResetStartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/password/reset-start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSignup = <ThrowOnError extends boolean = false>(options: Options<PostSignupData, ThrowOnError>): RequestResult<PostSignupResponses, PostSignupErrors, ThrowOnError> => (options.client ?? client).post<PostSignupResponses, PostSignupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAuthAddPhoneRs = <ThrowOnError extends boolean = false>(options: Options<PostAuthAddPhoneRsData, ThrowOnError>): RequestResult<PostAuthAddPhoneRsResponses, PostAuthAddPhoneRsErrors, ThrowOnError> => (options.client ?? client).post<PostAuthAddPhoneRsResponses, PostAuthAddPhoneRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth_rs/add_phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAuthLoginRs = <ThrowOnError extends boolean = false>(options: Options<PostAuthLoginRsData, ThrowOnError>): RequestResult<PostAuthLoginRsResponses, PostAuthLoginRsErrors, ThrowOnError> => (options.client ?? client).post<PostAuthLoginRsResponses, PostAuthLoginRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth_rs/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAuthLogoutRs = <ThrowOnError extends boolean = false>(options?: Options<PostAuthLogoutRsData, ThrowOnError>): RequestResult<PostAuthLogoutRsResponses, PostAuthLogoutRsErrors, ThrowOnError> => (options?.client ?? client).post<PostAuthLogoutRsResponses, PostAuthLogoutRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth_rs/logout',
    ...options
});

export const postAuthResendCodeRs = <ThrowOnError extends boolean = false>(options: Options<PostAuthResendCodeRsData, ThrowOnError>): RequestResult<PostAuthResendCodeRsResponses, PostAuthResendCodeRsErrors, ThrowOnError> => (options.client ?? client).post<PostAuthResendCodeRsResponses, PostAuthResendCodeRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth_rs/resend_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAuthVerifyOtpRs = <ThrowOnError extends boolean = false>(options: Options<PostAuthVerifyOtpRsData, ThrowOnError>): RequestResult<PostAuthVerifyOtpRsResponses, PostAuthVerifyOtpRsErrors, ThrowOnError> => (options.client ?? client).post<PostAuthVerifyOtpRsResponses, PostAuthVerifyOtpRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/auth_rs/verify_otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listCamera = <ThrowOnError extends boolean = false>(options?: Options<ListCameraData, ThrowOnError>): RequestResult<ListCameraResponses, ListCameraErrors, ThrowOnError> => (options?.client ?? client).get<ListCameraResponses, ListCameraErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/camera_list',
    ...options
});

export const getPoliceService = <ThrowOnError extends boolean = false>(options?: Options<GetPoliceServiceData, ThrowOnError>): RequestResult<GetPoliceServiceResponses, GetPoliceServiceErrors, ThrowOnError> => (options?.client ?? client).get<GetPoliceServiceResponses, GetPoliceServiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/police_service',
    ...options
});

export const patchPoliceService = <ThrowOnError extends boolean = false>(options: Options<PatchPoliceServiceData, ThrowOnError>): RequestResult<PatchPoliceServiceResponses, PatchPoliceServiceErrors, ThrowOnError> => (options.client ?? client).patch<PatchPoliceServiceResponses, PatchPoliceServiceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/police_service',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putPropertyPortal = <ThrowOnError extends boolean = false>(options: Options<PutPropertyPortalData, ThrowOnError>): RequestResult<PutPropertyPortalResponses, PutPropertyPortalErrors, ThrowOnError> => (options.client ?? client).put<PutPropertyPortalResponses, PutPropertyPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deletePropertyPortal = <ThrowOnError extends boolean = false>(options: Options<DeletePropertyPortalData, ThrowOnError>): RequestResult<DeletePropertyPortalResponses, DeletePropertyPortalErrors, ThrowOnError> => (options.client ?? client).delete<DeletePropertyPortalResponses, DeletePropertyPortalErrors, ThrowOnError>({ url: '/camera_registry/portal/property/{property_id}', ...options });

export const getPropertyPortal = <ThrowOnError extends boolean = false>(options: Options<GetPropertyPortalData, ThrowOnError>): RequestResult<GetPropertyPortalResponses, GetPropertyPortalErrors, ThrowOnError> => (options.client ?? client).get<GetPropertyPortalResponses, GetPropertyPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}',
    ...options
});

export const patchPropertyPortal = <ThrowOnError extends boolean = false>(options: Options<PatchPropertyPortalData, ThrowOnError>): RequestResult<PatchPropertyPortalResponses, PatchPropertyPortalErrors, ThrowOnError> => (options.client ?? client).patch<PatchPropertyPortalResponses, PatchPropertyPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putCameraPortal = <ThrowOnError extends boolean = false>(options: Options<PutCameraPortalData, ThrowOnError>): RequestResult<PutCameraPortalResponses, PutCameraPortalErrors, ThrowOnError> => (options.client ?? client).put<PutCameraPortalResponses, PutCameraPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}/camera',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteCameraPortal = <ThrowOnError extends boolean = false>(options: Options<DeleteCameraPortalData, ThrowOnError>): RequestResult<DeleteCameraPortalResponses, DeleteCameraPortalErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCameraPortalResponses, DeleteCameraPortalErrors, ThrowOnError>({ url: '/camera_registry/portal/property/{property_id}/camera/{camera_id}', ...options });

export const patchCameraPortal = <ThrowOnError extends boolean = false>(options: Options<PatchCameraPortalData, ThrowOnError>): RequestResult<PatchCameraPortalResponses, PatchCameraPortalErrors, ThrowOnError> => (options.client ?? client).patch<PatchCameraPortalResponses, PatchCameraPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}/camera/{camera_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putContactPortal = <ThrowOnError extends boolean = false>(options: Options<PutContactPortalData, ThrowOnError>): RequestResult<PutContactPortalResponses, PutContactPortalErrors, ThrowOnError> => (options.client ?? client).put<PutContactPortalResponses, PutContactPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteContactPortal = <ThrowOnError extends boolean = false>(options: Options<DeleteContactPortalData, ThrowOnError>): RequestResult<DeleteContactPortalResponses, DeleteContactPortalErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContactPortalResponses, DeleteContactPortalErrors, ThrowOnError>({ url: '/camera_registry/portal/property/{property_id}/contact/{contact_id}', ...options });

export const patchContactPortal = <ThrowOnError extends boolean = false>(options: Options<PatchContactPortalData, ThrowOnError>): RequestResult<PatchContactPortalResponses, PatchContactPortalErrors, ThrowOnError> => (options.client ?? client).patch<PatchContactPortalResponses, PatchContactPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}/contact/{contact_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postPropertySubmitPortal = <ThrowOnError extends boolean = false>(options: Options<PostPropertySubmitPortalData, ThrowOnError>): RequestResult<PostPropertySubmitPortalResponses, PostPropertySubmitPortalErrors, ThrowOnError> => (options.client ?? client).post<PostPropertySubmitPortalResponses, PostPropertySubmitPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/portal/property/{property_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getModifyListPublic = <ThrowOnError extends boolean = false>(options?: Options<GetModifyListPublicData, ThrowOnError>): RequestResult<GetModifyListPublicResponses, GetModifyListPublicErrors, ThrowOnError> => (options?.client ?? client).get<GetModifyListPublicResponses, GetModifyListPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/modify_list',
    ...options
});

export const postModifyRequestPublic = <ThrowOnError extends boolean = false>(options: Options<PostModifyRequestPublicData, ThrowOnError>): RequestResult<PostModifyRequestPublicResponses, PostModifyRequestPublicErrors, ThrowOnError> => (options.client ?? client).post<PostModifyRequestPublicResponses, PostModifyRequestPublicErrors, ThrowOnError>({
    url: '/camera_registry/public/modify_request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putPropertyPublic = <ThrowOnError extends boolean = false>(options: Options<PutPropertyPublicData, ThrowOnError>): RequestResult<PutPropertyPublicResponses, PutPropertyPublicErrors, ThrowOnError> => (options.client ?? client).put<PutPropertyPublicResponses, PutPropertyPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deletePropertyPublic = <ThrowOnError extends boolean = false>(options: Options<DeletePropertyPublicData, ThrowOnError>): RequestResult<DeletePropertyPublicResponses, DeletePropertyPublicErrors, ThrowOnError> => (options.client ?? client).delete<DeletePropertyPublicResponses, DeletePropertyPublicErrors, ThrowOnError>({ url: '/camera_registry/public/property/{property_id}', ...options });

export const getPropertyPublic = <ThrowOnError extends boolean = false>(options: Options<GetPropertyPublicData, ThrowOnError>): RequestResult<GetPropertyPublicResponses, GetPropertyPublicErrors, ThrowOnError> => (options.client ?? client).get<GetPropertyPublicResponses, GetPropertyPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}',
    ...options
});

export const patchPropertyPublic = <ThrowOnError extends boolean = false>(options: Options<PatchPropertyPublicData, ThrowOnError>): RequestResult<PatchPropertyPublicResponses, PatchPropertyPublicErrors, ThrowOnError> => (options.client ?? client).patch<PatchPropertyPublicResponses, PatchPropertyPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putCameraPublic = <ThrowOnError extends boolean = false>(options: Options<PutCameraPublicData, ThrowOnError>): RequestResult<PutCameraPublicResponses, PutCameraPublicErrors, ThrowOnError> => (options.client ?? client).put<PutCameraPublicResponses, PutCameraPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/camera',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteCameraPublic = <ThrowOnError extends boolean = false>(options: Options<DeleteCameraPublicData, ThrowOnError>): RequestResult<DeleteCameraPublicResponses, DeleteCameraPublicErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCameraPublicResponses, DeleteCameraPublicErrors, ThrowOnError>({ url: '/camera_registry/public/property/{property_id}/camera/{camera_id}', ...options });

export const patchCameraPublic = <ThrowOnError extends boolean = false>(options: Options<PatchCameraPublicData, ThrowOnError>): RequestResult<PatchCameraPublicResponses, PatchCameraPublicErrors, ThrowOnError> => (options.client ?? client).patch<PatchCameraPublicResponses, PatchCameraPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/camera/{camera_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPropertyCamerasCheckPublic = <ThrowOnError extends boolean = false>(options: Options<GetPropertyCamerasCheckPublicData, ThrowOnError>): RequestResult<GetPropertyCamerasCheckPublicResponses, GetPropertyCamerasCheckPublicErrors, ThrowOnError> => (options.client ?? client).get<GetPropertyCamerasCheckPublicResponses, GetPropertyCamerasCheckPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/cameras_check',
    ...options
});

export const putContactPublic = <ThrowOnError extends boolean = false>(options: Options<PutContactPublicData, ThrowOnError>): RequestResult<PutContactPublicResponses, PutContactPublicErrors, ThrowOnError> => (options.client ?? client).put<PutContactPublicResponses, PutContactPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteContactPublic = <ThrowOnError extends boolean = false>(options: Options<DeleteContactPublicData, ThrowOnError>): RequestResult<DeleteContactPublicResponses, DeleteContactPublicErrors, ThrowOnError> => (options.client ?? client).delete<DeleteContactPublicResponses, DeleteContactPublicErrors, ThrowOnError>({ url: '/camera_registry/public/property/{property_id}/contact/{contact_id}', ...options });

export const patchContactPublic = <ThrowOnError extends boolean = false>(options: Options<PatchContactPublicData, ThrowOnError>): RequestResult<PatchContactPublicResponses, PatchContactPublicErrors, ThrowOnError> => (options.client ?? client).patch<PatchContactPublicResponses, PatchContactPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/contact/{contact_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPropertyContactsCheckPublic = <ThrowOnError extends boolean = false>(options: Options<GetPropertyContactsCheckPublicData, ThrowOnError>): RequestResult<GetPropertyContactsCheckPublicResponses, GetPropertyContactsCheckPublicErrors, ThrowOnError> => (options.client ?? client).get<GetPropertyContactsCheckPublicResponses, GetPropertyContactsCheckPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/contacts_check',
    ...options
});

export const getPropertyLocationCheckPublic = <ThrowOnError extends boolean = false>(options: Options<GetPropertyLocationCheckPublicData, ThrowOnError>): RequestResult<GetPropertyLocationCheckPublicResponses, GetPropertyLocationCheckPublicErrors, ThrowOnError> => (options.client ?? client).get<GetPropertyLocationCheckPublicResponses, GetPropertyLocationCheckPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/location_check',
    ...options
});

export const postPropertySubmitPublic = <ThrowOnError extends boolean = false>(options: Options<PostPropertySubmitPublicData, ThrowOnError>): RequestResult<PostPropertySubmitPublicResponses, PostPropertySubmitPublicErrors, ThrowOnError> => (options.client ?? client).post<PostPropertySubmitPublicResponses, PostPropertySubmitPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/camera_registry/public/property/{property_id}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putUserCr = <ThrowOnError extends boolean = false>(options: Options<PutUserCrData, ThrowOnError>): RequestResult<PutUserCrResponses, PutUserCrErrors, ThrowOnError> => (options.client ?? client).put<PutUserCrResponses, PutUserCrErrors, ThrowOnError>({
    url: '/camera_registry/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postChatkitSession = <ThrowOnError extends boolean = false>(options?: Options<PostChatkitSessionData, ThrowOnError>): RequestResult<PostChatkitSessionResponses, PostChatkitSessionErrors, ThrowOnError> => (options?.client ?? client).post<PostChatkitSessionResponses, PostChatkitSessionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/chatkit/session',
    ...options
});

export const getConnectAvailabilityPublic = <ThrowOnError extends boolean = false>(options: Options<GetConnectAvailabilityPublicData, ThrowOnError>): RequestResult<GetConnectAvailabilityPublicResponses, GetConnectAvailabilityPublicErrors, ThrowOnError> => (options.client ?? client).get<GetConnectAvailabilityPublicResponses, GetConnectAvailabilityPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/booking/{org_id}/available-slots',
    ...options
});

export const postConnectBookingPublic = <ThrowOnError extends boolean = false>(options: Options<PostConnectBookingPublicData, ThrowOnError>): RequestResult<PostConnectBookingPublicResponses, PostConnectBookingPublicErrors, ThrowOnError> => (options.client ?? client).post<PostConnectBookingPublicResponses, PostConnectBookingPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/booking/{org_id}/book',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConnectInvitationInfo = <ThrowOnError extends boolean = false>(options: Options<GetConnectInvitationInfoData, ThrowOnError>): RequestResult<GetConnectInvitationInfoResponses, GetConnectInvitationInfoErrors, ThrowOnError> => (options.client ?? client).get<GetConnectInvitationInfoResponses, GetConnectInvitationInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}',
    ...options
});

/**
 * Records the recipient's acknowledgement of the notice statement. The
 * recipient is blocked (in the UI) from continuing until this is called.
 */
export const postConnectInvitationAcknowledge = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationAcknowledgeData, ThrowOnError>): RequestResult<PostConnectInvitationAcknowledgeResponses, PostConnectInvitationAcknowledgeErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationAcknowledgeResponses, PostConnectInvitationAcknowledgeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/acknowledge',
    ...options
});

/**
 * The subject's client reports an **involuntary** media interruption — a
 * camera/mic track ending or a permission lost mid-call. The subject cannot
 * self-mute (media matrix), so this is how device/permission loss reaches the
 * interviewer (officer UI reads these audit events) and the audit trail. The
 * client reports transitions, so this is naturally diff-based.
 */
export const postConnectInvitationInterruption = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationInterruptionData, ThrowOnError>): RequestResult<PostConnectInvitationInterruptionResponses, PostConnectInvitationInterruptionErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationInterruptionResponses, PostConnectInvitationInterruptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/interruption',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issues a LiveKit token for an admitted recipient. Per the waiting-room
 * design, the token is only granted once an officer has admitted them, so
 * this rejects any recipient not in the `admitted` state. Observers receive
 * a view-only (no-publish) grant.
 */
export const postConnectInvitationJoin = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationJoinData, ThrowOnError>): RequestResult<PostConnectInvitationJoinResponses, PostConnectInvitationJoinErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationJoinResponses, PostConnectInvitationJoinErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/join',
    ...options
});

/**
 * The subject leaves the interview (Phase L). Marks the live participant as
 * left, disconnects them from LiveKit, and re-queues the invitation to the
 * waiting room so a rejoin (via the same link, while the meeting is active) is
 * re-admitted by the officer. Audited as `participant_left`.
 */
export const postConnectInvitationLeave = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationLeaveData, ThrowOnError>): RequestResult<PostConnectInvitationLeaveResponses, PostConnectInvitationLeaveErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationLeaveResponses, PostConnectInvitationLeaveErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/leave',
    ...options
});

/**
 * Records a periodic device-location sample for an admitted subject during a
 * live interview (~1/min). Every sample is stored in connect_location_ping and
 * the invitation's last-known location is refreshed when available. Only
 * availability transitions (unavailable / restored) are audited — the
 * per-sample history lives in the ping table, so we avoid one audit row a
 * minute.
 */
export const postConnectInvitationLocation = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationLocationData, ThrowOnError>): RequestResult<PostConnectInvitationLocationResponses, PostConnectInvitationLocationErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationLocationResponses, PostConnectInvitationLocationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Records camera/microphone/location permission status (and last known
 * location + device info). Callable repeatedly to re-request or refresh.
 * Once the type's required media are granted the recipient enters the
 * waiting room.
 */
export const postConnectInvitationPermissions = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationPermissionsData, ThrowOnError>): RequestResult<PostConnectInvitationPermissionsResponses, PostConnectInvitationPermissionsErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationPermissionsResponses, PostConnectInvitationPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The subject requests a pause (Phase L). Fires instantly, with no confirm;
 * the meeting keeps running (and recording) until an interviewer actually
 * pauses. Audited as `pause_requested`; the officer UI surfaces it.
 */
export const postConnectInvitationRequestPause = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationRequestPauseData, ThrowOnError>): RequestResult<PostConnectInvitationRequestPauseResponses, PostConnectInvitationRequestPauseErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationRequestPauseResponses, PostConnectInvitationRequestPauseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/request-pause',
    ...options
});

/**
 * The subject withdraws a pending pause request (mockup 12: "Request Pause"
 * becomes "Cancel Request" while pending). Purely an audit signal — the
 * officer's monitor panel reads both events.
 */
export const postConnectInvitationRequestPauseCancel = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationRequestPauseCancelData, ThrowOnError>): RequestResult<PostConnectInvitationRequestPauseCancelResponses, PostConnectInvitationRequestPauseCancelErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationRequestPauseCancelResponses, PostConnectInvitationRequestPauseCancelErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/request-pause/cancel',
    ...options
});

/**
 * Waiting-room poll. Returns the recipient's current status; `admitted` flips
 * to true once an officer admits them (Phase D), at which point the client
 * requests a LiveKit token to connect.
 */
export const getConnectInvitationStatus = <ThrowOnError extends boolean = false>(options: Options<GetConnectInvitationStatusData, ThrowOnError>): RequestResult<GetConnectInvitationStatusResponses, GetConnectInvitationStatusErrors, ThrowOnError> => (options.client ?? client).get<GetConnectInvitationStatusResponses, GetConnectInvitationStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/invitation/{token}/status',
    ...options
});

export const getConnectMeetingJoinInfo = <ThrowOnError extends boolean = false>(options: Options<GetConnectMeetingJoinInfoData, ThrowOnError>): RequestResult<GetConnectMeetingJoinInfoResponses, GetConnectMeetingJoinInfoErrors, ThrowOnError> => (options.client ?? client).get<GetConnectMeetingJoinInfoResponses, GetConnectMeetingJoinInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/meeting/join/{join_token}',
    ...options
});

export const postConnectMeetingJoinPublic = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingJoinPublicData, ThrowOnError>): RequestResult<PostConnectMeetingJoinPublicResponses, PostConnectMeetingJoinPublicErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingJoinPublicResponses, PostConnectMeetingJoinPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/meeting/join/{join_token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConnectAvailability = <ThrowOnError extends boolean = false>(options: Options<GetConnectAvailabilityData, ThrowOnError>): RequestResult<GetConnectAvailabilityResponses, GetConnectAvailabilityErrors, ThrowOnError> => (options.client ?? client).get<GetConnectAvailabilityResponses, GetConnectAvailabilityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/availability',
    ...options
});

export const putConnectAvailability = <ThrowOnError extends boolean = false>(options: Options<PutConnectAvailabilityData, ThrowOnError>): RequestResult<PutConnectAvailabilityResponses, PutConnectAvailabilityErrors, ThrowOnError> => (options.client ?? client).put<PutConnectAvailabilityResponses, PutConnectAvailabilityErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/availability',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchConnectBooking = <ThrowOnError extends boolean = false>(options: Options<PatchConnectBookingData, ThrowOnError>): RequestResult<PatchConnectBookingResponses, PatchConnectBookingErrors, ThrowOnError> => (options.client ?? client).patch<PatchConnectBookingResponses, PatchConnectBookingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/booking/{booking_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listConnectBooking = <ThrowOnError extends boolean = false>(options: Options<ListConnectBookingData, ThrowOnError>): RequestResult<ListConnectBookingResponses, ListConnectBookingErrors, ThrowOnError> => (options.client ?? client).get<ListConnectBookingResponses, ListConnectBookingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/bookings',
    ...options
});

export const postConnectMeeting = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingData, ThrowOnError>): RequestResult<PostConnectMeetingResponses, PostConnectMeetingErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingResponses, PostConnectMeetingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteConnectMeeting = <ThrowOnError extends boolean = false>(options: Options<DeleteConnectMeetingData, ThrowOnError>): RequestResult<DeleteConnectMeetingResponses, DeleteConnectMeetingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConnectMeetingResponses, DeleteConnectMeetingErrors, ThrowOnError>({ url: '/connect/org/{org_id}/meeting/{meeting_id}', ...options });

export const getConnectMeeting = <ThrowOnError extends boolean = false>(options: Options<GetConnectMeetingData, ThrowOnError>): RequestResult<GetConnectMeetingResponses, GetConnectMeetingErrors, ThrowOnError> => (options.client ?? client).get<GetConnectMeetingResponses, GetConnectMeetingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}',
    ...options
});

export const patchConnectMeeting = <ThrowOnError extends boolean = false>(options: Options<PatchConnectMeetingData, ThrowOnError>): RequestResult<PatchConnectMeetingResponses, PatchConnectMeetingErrors, ThrowOnError> => (options.client ?? client).patch<PatchConnectMeetingResponses, PatchConnectMeetingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The session audit trail (chronological). Surfaces the events Round 2 will
 * package into the Evidence.com companion file.
 */
export const getConnectAudit = <ThrowOnError extends boolean = false>(options: Options<GetConnectAuditData, ThrowOnError>): RequestResult<GetConnectAuditResponses, GetConnectAuditErrors, ThrowOnError> => (options.client ?? client).get<GetConnectAuditResponses, GetConnectAuditErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/audit',
    ...options
});

export const getConnectMeetingDialIn = <ThrowOnError extends boolean = false>(options: Options<GetConnectMeetingDialInData, ThrowOnError>): RequestResult<GetConnectMeetingDialInResponses, GetConnectMeetingDialInErrors, ThrowOnError> => (options.client ?? client).get<GetConnectMeetingDialInResponses, GetConnectMeetingDialInErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/dial-in',
    ...options
});

export const postConnectMeetingDialOut = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingDialOutData, ThrowOnError>): RequestResult<PostConnectMeetingDialOutResponses, PostConnectMeetingDialOutErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingDialOutResponses, PostConnectMeetingDialOutErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/dial-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postConnectMeetingEnd = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingEndData, ThrowOnError>): RequestResult<PostConnectMeetingEndResponses, PostConnectMeetingEndErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingEndResponses, PostConnectMeetingEndErrors, ThrowOnError>({ url: '/connect/org/{org_id}/meeting/{meeting_id}/end', ...options });

/**
 * Stores an officer-captured still for the session in S3 (no ID gate). Shown
 * in the history view and shipped to Evidence.com with the recording.
 */
export const postConnectImage = <ThrowOnError extends boolean = false>(options: Options<PostConnectImageData, ThrowOnError>): RequestResult<PostConnectImageResponses, PostConnectImageErrors, ThrowOnError> => (options.client ?? client).post<PostConnectImageResponses, PostConnectImageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/image',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists the officer-captured stills for a meeting, each with a short-lived
 * presigned URL for display.
 */
export const getConnectImages = <ThrowOnError extends boolean = false>(options: Options<GetConnectImagesData, ThrowOnError>): RequestResult<GetConnectImagesResponses, GetConnectImagesErrors, ThrowOnError> => (options.client ?? client).get<GetConnectImagesResponses, GetConnectImagesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/images',
    ...options
});

export const postConnectInvitation = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationData, ThrowOnError>): RequestResult<PostConnectInvitationResponses, PostConnectInvitationErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationResponses, PostConnectInvitationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The portal copied an invitation's join link to the clipboard so the officer
 * can send it by an approved method outside RubiCONNECT. Recording it keeps
 * the audit trail complete for links that never went through email/SMS.
 */
export const postConnectInvitationCopied = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationCopiedData, ThrowOnError>): RequestResult<PostConnectInvitationCopiedResponses, PostConnectInvitationCopiedErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationCopiedResponses, PostConnectInvitationCopiedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/invitation/{invitation_id}/copied',
    ...options
});

/**
 * Officer decision on a waiting-room recipient. `admit` lets them join (the
 * LiveKit token is issued when their client calls the public join endpoint);
 * `decline`/`remove` revokes access.
 */
export const postConnectInvitationDecision = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationDecisionData, ThrowOnError>): RequestResult<PostConnectInvitationDecisionResponses, PostConnectInvitationDecisionErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationDecisionResponses, PostConnectInvitationDecisionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/invitation/{invitation_id}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postConnectInvitationSend = <ThrowOnError extends boolean = false>(options: Options<PostConnectInvitationSendData, ThrowOnError>): RequestResult<PostConnectInvitationSendResponses, PostConnectInvitationSendErrors, ThrowOnError> => (options.client ?? client).post<PostConnectInvitationSendResponses, PostConnectInvitationSendErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/invitation/{invitation_id}/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConnectInvitations = <ThrowOnError extends boolean = false>(options: Options<GetConnectInvitationsData, ThrowOnError>): RequestResult<GetConnectInvitationsResponses, GetConnectInvitationsErrors, ThrowOnError> => (options.client ?? client).get<GetConnectInvitationsResponses, GetConnectInvitationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/invitations',
    ...options
});

/**
 * Recent device-location samples for a meeting (newest first), for the
 * officer's live location view during an interview.
 */
export const getConnectLocations = <ThrowOnError extends boolean = false>(options: Options<GetConnectLocationsData, ThrowOnError>): RequestResult<GetConnectLocationsResponses, GetConnectLocationsErrors, ThrowOnError> => (options.client ?? client).get<GetConnectLocationsResponses, GetConnectLocationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/locations',
    ...options
});

/**
 * Officer control (Phase K): remotely mute/unmute a recipient's microphone
 * and/or disable/enable their camera. The subject cannot toggle their own
 * media (media matrix), so this is how an interviewer manages it. Targets an
 * invited recipient by invitation id (LiveKit identity `invitee-{id}`).
 */
export const postConnectParticipantMedia = <ThrowOnError extends boolean = false>(options: Options<PostConnectParticipantMediaData, ThrowOnError>): RequestResult<PostConnectParticipantMediaResponses, PostConnectParticipantMediaErrors, ThrowOnError> => (options.client ?? client).post<PostConnectParticipantMediaResponses, PostConnectParticipantMediaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/participant/{invitation_id}/media',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Officer asks a participant who joined without video to turn their camera
 * on. The camera is optional at join and can't be switched on remotely, so
 * this stamps a request on the participant's LiveKit attributes, which the
 * subject's client turns into a prompt ("Turn camera on" / "Not now"); the
 * ask itself is audited.
 */
export const postConnectParticipantCameraRequest = <ThrowOnError extends boolean = false>(options: Options<PostConnectParticipantCameraRequestData, ThrowOnError>): RequestResult<PostConnectParticipantCameraRequestResponses, PostConnectParticipantCameraRequestErrors, ThrowOnError> => (options.client ?? client).post<PostConnectParticipantCameraRequestResponses, PostConnectParticipantCameraRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/participant/{invitation_id}/request-camera',
    ...options
});

/**
 * Pauses or resumes the meeting for the given target. On pause, targeted
 * participants are disconnected and held for a manual re-admit.
 */
export const postConnectMeetingPause = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingPauseData, ThrowOnError>): RequestResult<PostConnectMeetingPauseResponses, PostConnectMeetingPauseErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingPauseResponses, PostConnectMeetingPauseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Manually (re-)trigger the Evidence.com export for a recording (Phase N) —
 * e.g. after a failed auto-export, within the retention window. Fire-and-
 * forget: marks the recording re-export-requested and spawns the export.
 */
export const postConnectRecordingExport = <ThrowOnError extends boolean = false>(options: Options<PostConnectRecordingExportData, ThrowOnError>): RequestResult<PostConnectRecordingExportResponses, PostConnectRecordingExportErrors, ThrowOnError> => (options.client ?? client).post<PostConnectRecordingExportResponses, PostConnectRecordingExportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/recording/{recording_id}/export',
    ...options
});

export const listConnectRecording = <ThrowOnError extends boolean = false>(options: Options<ListConnectRecordingData, ThrowOnError>): RequestResult<ListConnectRecordingResponses, ListConnectRecordingErrors, ThrowOnError> => (options.client ?? client).get<ListConnectRecordingResponses, ListConnectRecordingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/recordings',
    ...options
});

export const postConnectMeetingToken = <ThrowOnError extends boolean = false>(options: Options<PostConnectMeetingTokenData, ThrowOnError>): RequestResult<PostConnectMeetingTokenResponses, PostConnectMeetingTokenErrors, ThrowOnError> => (options.client ?? client).post<PostConnectMeetingTokenResponses, PostConnectMeetingTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meeting/{meeting_id}/token',
    ...options
});

/**
 * Org-wide list of meetings with their derived lifecycle — the "history of
 * all video calls" from the product spec. Filters run on the derived status,
 * so they're applied after the rows are summarised; paging happens last.
 */
export const listConnectMeeting = <ThrowOnError extends boolean = false>(options: Options<ListConnectMeetingData, ThrowOnError>): RequestResult<ListConnectMeetingResponses, ListConnectMeetingErrors, ThrowOnError> => (options.client ?? client).get<ListConnectMeetingResponses, ListConnectMeetingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/meetings',
    ...options
});

export const postConnectOccurrence = <ThrowOnError extends boolean = false>(options: Options<PostConnectOccurrenceData, ThrowOnError>): RequestResult<PostConnectOccurrenceResponses, PostConnectOccurrenceErrors, ThrowOnError> => (options.client ?? client).post<PostConnectOccurrenceResponses, PostConnectOccurrenceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/occurrence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve an occurrence by its exact number. Used by the officer UI both to
 * offer "open existing" when a create collides and to search before creating.
 */
export const getConnectOccurrenceLookup = <ThrowOnError extends boolean = false>(options: Options<GetConnectOccurrenceLookupData, ThrowOnError>): RequestResult<GetConnectOccurrenceLookupResponses, GetConnectOccurrenceLookupErrors, ThrowOnError> => (options.client ?? client).get<GetConnectOccurrenceLookupResponses, GetConnectOccurrenceLookupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/occurrence-lookup',
    ...options
});

export const getConnectOccurrence = <ThrowOnError extends boolean = false>(options: Options<GetConnectOccurrenceData, ThrowOnError>): RequestResult<GetConnectOccurrenceResponses, GetConnectOccurrenceErrors, ThrowOnError> => (options.client ?? client).get<GetConnectOccurrenceResponses, GetConnectOccurrenceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/occurrence/{occurrence_id}',
    ...options
});

export const listConnectOccurrence = <ThrowOnError extends boolean = false>(options: Options<ListConnectOccurrenceData, ThrowOnError>): RequestResult<ListConnectOccurrenceResponses, ListConnectOccurrenceErrors, ThrowOnError> => (options.client ?? client).get<ListConnectOccurrenceResponses, ListConnectOccurrenceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/occurrences',
    ...options
});

export const getConnectRecording = <ThrowOnError extends boolean = false>(options: Options<GetConnectRecordingData, ThrowOnError>): RequestResult<GetConnectRecordingResponses, GetConnectRecordingErrors, ThrowOnError> => (options.client ?? client).get<GetConnectRecordingResponses, GetConnectRecordingErrors, ThrowOnError>({
    responseType: 'json',
    url: '/connect/org/{org_id}/recording/{recording_id}',
    ...options
});

/**
 * Single LiveKit webhook sink. LiveKit posts *all* event types to the one
 * configured URL, so this dispatches: egress_* → recording lifecycle;
 * participant_*track_* → session interruption tracking (Phase J).
 */
export const postWebhookLivekitEgress = <ThrowOnError extends boolean = false>(options?: Options<PostWebhookLivekitEgressData, ThrowOnError>): RequestResult<PostWebhookLivekitEgressResponses, PostWebhookLivekitEgressErrors, ThrowOnError> => (options?.client ?? client).post<PostWebhookLivekitEgressResponses, PostWebhookLivekitEgressErrors, ThrowOnError>({ url: '/connect/webhook/egress', ...options });

export const listConversation = <ThrowOnError extends boolean = false>(options?: Options<ListConversationData, ThrowOnError>): RequestResult<ListConversationResponses, ListConversationErrors, ThrowOnError> => (options?.client ?? client).get<ListConversationResponses, ListConversationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation',
    ...options
});

export const postConversation = <ThrowOnError extends boolean = false>(options: Options<PostConversationData, ThrowOnError>): RequestResult<PostConversationResponses, PostConversationErrors, ThrowOnError> => (options.client ?? client).post<PostConversationResponses, PostConversationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConversation = <ThrowOnError extends boolean = false>(options: Options<GetConversationData, ThrowOnError>): RequestResult<GetConversationResponses, GetConversationErrors, ThrowOnError> => (options.client ?? client).get<GetConversationResponses, GetConversationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation/{conversation_id}',
    ...options
});

export const patchConversation = <ThrowOnError extends boolean = false>(options: Options<PatchConversationData, ThrowOnError>): RequestResult<PatchConversationResponses, PatchConversationErrors, ThrowOnError> => (options.client ?? client).patch<PatchConversationResponses, PatchConversationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation/{conversation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConversationAuditLog = <ThrowOnError extends boolean = false>(options: Options<GetConversationAuditLogData, ThrowOnError>): RequestResult<GetConversationAuditLogResponses, GetConversationAuditLogErrors, ThrowOnError> => (options.client ?? client).get<GetConversationAuditLogResponses, GetConversationAuditLogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation/{conversation_id}/audit_log',
    ...options
});

export const postConversationOutboundMessage = <ThrowOnError extends boolean = false>(options: Options<PostConversationOutboundMessageData, ThrowOnError>): RequestResult<PostConversationOutboundMessageResponses, PostConversationOutboundMessageErrors, ThrowOnError> => (options.client ?? client).post<PostConversationOutboundMessageResponses, PostConversationOutboundMessageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation/{conversation_id}/outbound_message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConversationClient = <ThrowOnError extends boolean = false>(options: Options<GetConversationClientData, ThrowOnError>): RequestResult<GetConversationClientResponses, GetConversationClientErrors, ThrowOnError> => (options.client ?? client).get<GetConversationClientResponses, GetConversationClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_client',
    ...options
});

export const patchConversationClient = <ThrowOnError extends boolean = false>(options: Options<PatchConversationClientData, ThrowOnError>): RequestResult<PatchConversationClientResponses, PatchConversationClientErrors, ThrowOnError> => (options.client ?? client).patch<PatchConversationClientResponses, PatchConversationClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_client/{conversation_client_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listConversationTemplate = <ThrowOnError extends boolean = false>(options?: Options<ListConversationTemplateData, ThrowOnError>): RequestResult<ListConversationTemplateResponses, ListConversationTemplateErrors, ThrowOnError> => (options?.client ?? client).get<ListConversationTemplateResponses, ListConversationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template',
    ...options
});

export const postConversationTemplate = <ThrowOnError extends boolean = false>(options: Options<PostConversationTemplateData, ThrowOnError>): RequestResult<PostConversationTemplateResponses, PostConversationTemplateErrors, ThrowOnError> => (options.client ?? client).post<PostConversationTemplateResponses, PostConversationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteConversationTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationTemplateData, ThrowOnError>): RequestResult<DeleteConversationTemplateResponses, DeleteConversationTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConversationTemplateResponses, DeleteConversationTemplateErrors, ThrowOnError>({ url: '/conversation_template/{conversation_template_id}', ...options });

export const getConversationTemplate = <ThrowOnError extends boolean = false>(options: Options<GetConversationTemplateData, ThrowOnError>): RequestResult<GetConversationTemplateResponses, GetConversationTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetConversationTemplateResponses, GetConversationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template/{conversation_template_id}',
    ...options
});

export const patchConversationTemplate = <ThrowOnError extends boolean = false>(options: Options<PatchConversationTemplateData, ThrowOnError>): RequestResult<PatchConversationTemplateResponses, PatchConversationTemplateErrors, ThrowOnError> => (options.client ?? client).patch<PatchConversationTemplateResponses, PatchConversationTemplateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template/{conversation_template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteConversationTemplateContent = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationTemplateContentData, ThrowOnError>): RequestResult<DeleteConversationTemplateContentResponses, DeleteConversationTemplateContentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConversationTemplateContentResponses, DeleteConversationTemplateContentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template/{conversation_template_id}/content/{lang}',
    ...options
});

export const postConversationTemplateTranslate = <ThrowOnError extends boolean = false>(options: Options<PostConversationTemplateTranslateData, ThrowOnError>): RequestResult<PostConversationTemplateTranslateResponses, PostConversationTemplateTranslateErrors, ThrowOnError> => (options.client ?? client).post<PostConversationTemplateTranslateResponses, PostConversationTemplateTranslateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/conversation_template/{conversation_template_id}/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getDashboard = <ThrowOnError extends boolean = false>(options: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({ url: '/dashboard', ...options });

/**
 * List the titles of every Rubi org, sorted alphabetically.
 *
 * Intended to populate the org dropdown on the Intel side, so it requires the
 * caller to be a signed-in portal user with Intel app access.
 */
export const listIntelOrgTitles = <ThrowOnError extends boolean = false>(options?: Options<ListIntelOrgTitlesData, ThrowOnError>): RequestResult<ListIntelOrgTitlesResponses, ListIntelOrgTitlesErrors, ThrowOnError> => (options?.client ?? client).get<ListIntelOrgTitlesResponses, ListIntelOrgTitlesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/intel/org_titles',
    ...options
});

/**
 * List the current user's own intel (CISO) submissions that are in draft or modification_requested status.
 */
export const listMyIntelSubmission = <ThrowOnError extends boolean = false>(options?: Options<ListMyIntelSubmissionData, ThrowOnError>): RequestResult<ListMyIntelSubmissionResponses, ListMyIntelSubmissionErrors, ThrowOnError> => (options?.client ?? client).get<ListMyIntelSubmissionResponses, ListMyIntelSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/intel/submission',
    ...options
});

/**
 * Archive an intel submission. The submission's status is set to `archived`,
 * excluding it from subsequent list/search results.
 */
export const deleteIntelSubmission = <ThrowOnError extends boolean = false>(options: Options<DeleteIntelSubmissionData, ThrowOnError>): RequestResult<DeleteIntelSubmissionResponses, DeleteIntelSubmissionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntelSubmissionResponses, DeleteIntelSubmissionErrors, ThrowOnError>({ url: '/intel/submission/{id}', ...options });

export const listM2mClient = <ThrowOnError extends boolean = false>(options: Options<ListM2mClientData, ThrowOnError>): RequestResult<ListM2mClientResponses, ListM2mClientErrors, ThrowOnError> => (options.client ?? client).get<ListM2mClientResponses, ListM2mClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client',
    ...options
});

export const putM2mClient = <ThrowOnError extends boolean = false>(options: Options<PutM2mClientData, ThrowOnError>): RequestResult<PutM2mClientResponses, PutM2mClientErrors, ThrowOnError> => (options.client ?? client).put<PutM2mClientResponses, PutM2mClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getM2mClient = <ThrowOnError extends boolean = false>(options: Options<GetM2mClientData, ThrowOnError>): RequestResult<GetM2mClientResponses, GetM2mClientErrors, ThrowOnError> => (options.client ?? client).get<GetM2mClientResponses, GetM2mClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client/{client_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postM2mClient = <ThrowOnError extends boolean = false>(options: Options<PostM2mClientData, ThrowOnError>): RequestResult<PostM2mClientResponses, PostM2mClientErrors, ThrowOnError> => (options.client ?? client).post<PostM2mClientResponses, PostM2mClientErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client/{client_id}/authenticate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postM2mClientRotate = <ThrowOnError extends boolean = false>(options: Options<PostM2mClientRotateData, ThrowOnError>): RequestResult<PostM2mClientRotateResponses, PostM2mClientRotateErrors, ThrowOnError> => (options.client ?? client).post<PostM2mClientRotateResponses, PostM2mClientRotateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client/{client_id}/rotate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postM2mClientRotateCancel = <ThrowOnError extends boolean = false>(options: Options<PostM2mClientRotateCancelData, ThrowOnError>): RequestResult<PostM2mClientRotateCancelResponses, PostM2mClientRotateCancelErrors, ThrowOnError> => (options.client ?? client).post<PostM2mClientRotateCancelResponses, PostM2mClientRotateCancelErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client/{client_id}/rotate/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postM2mClientRotateStart = <ThrowOnError extends boolean = false>(options: Options<PostM2mClientRotateStartData, ThrowOnError>): RequestResult<PostM2mClientRotateStartResponses, PostM2mClientRotateStartErrors, ThrowOnError> => (options.client ?? client).post<PostM2mClientRotateStartResponses, PostM2mClientRotateStartErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_client/{client_id}/rotate/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getM2mRecordDownload = <ThrowOnError extends boolean = false>(options?: Options<GetM2mRecordDownloadData, ThrowOnError>): RequestResult<GetM2mRecordDownloadResponses, GetM2mRecordDownloadErrors, ThrowOnError> => (options?.client ?? client).get<GetM2mRecordDownloadResponses, GetM2mRecordDownloadErrors, ThrowOnError>({
    responseType: 'json',
    url: '/m2m_record_download',
    ...options
});

/**
 * Lists every rubi_user who is a participant in at least one conversation
 * belonging to `rubi_org_id`, along with the number of conversations they're
 * a participant of. Participation is established by sending an outbound
 * message, patching, or closing a conversation (see `add_participant` in
 * `message.rs`).
 */
export const listMessagingUser = <ThrowOnError extends boolean = false>(options?: Options<ListMessagingUserData, ThrowOnError>): RequestResult<ListMessagingUserResponses, ListMessagingUserErrors, ThrowOnError> => (options?.client ?? client).get<ListMessagingUserResponses, ListMessagingUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/messaging_user',
    ...options
});

export const getNewsletterMailingList = <ThrowOnError extends boolean = false>(options?: Options<GetNewsletterMailingListData, ThrowOnError>): RequestResult<GetNewsletterMailingListResponses, GetNewsletterMailingListErrors, ThrowOnError> => (options?.client ?? client).get<GetNewsletterMailingListResponses, GetNewsletterMailingListErrors, ThrowOnError>({ url: '/newsletter_mailing_list', ...options });

export const listOrg = <ThrowOnError extends boolean = false>(options?: Options<ListOrgData, ThrowOnError>): RequestResult<ListOrgResponses, ListOrgErrors, ThrowOnError> => (options?.client ?? client).get<ListOrgResponses, ListOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org',
    ...options
});

export const postOrg = <ThrowOnError extends boolean = false>(options: Options<PostOrgData, ThrowOnError>): RequestResult<PostOrgResponses, PostOrgErrors, ThrowOnError> => (options.client ?? client).post<PostOrgResponses, PostOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postOrgBootstrap = <ThrowOnError extends boolean = false>(options: Options<PostOrgBootstrapData, ThrowOnError>): RequestResult<PostOrgBootstrapResponses, PostOrgBootstrapErrors, ThrowOnError> => (options.client ?? client).post<PostOrgBootstrapResponses, PostOrgBootstrapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/bootstrap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteOrg = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgData, ThrowOnError>): RequestResult<DeleteOrgResponses, DeleteOrgErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgResponses, DeleteOrgErrors, ThrowOnError>({ url: '/org/{org_id}', ...options });

export const getOrg = <ThrowOnError extends boolean = false>(options: Options<GetOrgData, ThrowOnError>): RequestResult<GetOrgResponses, GetOrgErrors, ThrowOnError> => (options.client ?? client).get<GetOrgResponses, GetOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}',
    ...options
});

export const putOrg = <ThrowOnError extends boolean = false>(options: Options<PutOrgData, ThrowOnError>): RequestResult<PutOrgResponses, PutOrgErrors, ThrowOnError> => (options.client ?? client).put<PutOrgResponses, PutOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchOrgAdmin = <ThrowOnError extends boolean = false>(options: Options<PatchOrgAdminData, ThrowOnError>): RequestResult<PatchOrgAdminResponses, PatchOrgAdminErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrgAdminResponses, PatchOrgAdminErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List an Organization's uploaded geo data files, newest first.
 */
export const listGeoDataFile = <ThrowOnError extends boolean = false>(options: Options<ListGeoDataFileData, ThrowOnError>): RequestResult<ListGeoDataFileResponses, ListGeoDataFileErrors, ThrowOnError> => (options.client ?? client).get<ListGeoDataFileResponses, ListGeoDataFileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file',
    ...options
});

export const postGeoDataFile = <ThrowOnError extends boolean = false>(options: Options<PostGeoDataFileData, ThrowOnError>): RequestResult<PostGeoDataFileResponses, PostGeoDataFileErrors, ThrowOnError> => (options.client ?? client).post<PostGeoDataFileResponses, PostGeoDataFileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteGeoDataFile = <ThrowOnError extends boolean = false>(options: Options<DeleteGeoDataFileData, ThrowOnError>): RequestResult<DeleteGeoDataFileResponses, DeleteGeoDataFileErrors, ThrowOnError> => (options.client ?? client).delete<DeleteGeoDataFileResponses, DeleteGeoDataFileErrors, ThrowOnError>({ url: '/org/{org_id}/geo_data_file/{file_id}', ...options });

/**
 * Fetch one uploaded geo data file's record.
 */
export const getGeoDataFile = <ThrowOnError extends boolean = false>(options: Options<GetGeoDataFileData, ThrowOnError>): RequestResult<GetGeoDataFileResponses, GetGeoDataFileErrors, ThrowOnError> => (options.client ?? client).get<GetGeoDataFileResponses, GetGeoDataFileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file/{file_id}',
    ...options
});

export const postGeoDataFileComplete = <ThrowOnError extends boolean = false>(options: Options<PostGeoDataFileCompleteData, ThrowOnError>): RequestResult<PostGeoDataFileCompleteResponses, PostGeoDataFileCompleteErrors, ThrowOnError> => (options.client ?? client).post<PostGeoDataFileCompleteResponses, PostGeoDataFileCompleteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file/{file_id}/complete',
    ...options
});

/**
 * Start a processing run over an uploaded file.
 *
 * Returns immediately with the run in its initial `pending` state; poll
 * `GET /org/{org_id}/geo_data_file_processing_run/{run_id}` with the returned
 * `id` for the outcome. Runs are independent: starting one never deletes or
 * alters a prior run or its Subregions.
 */
export const postGeoDataFileProcess = <ThrowOnError extends boolean = false>(options: Options<PostGeoDataFileProcessData, ThrowOnError>): RequestResult<PostGeoDataFileProcessResponses, PostGeoDataFileProcessErrors, ThrowOnError> => (options.client ?? client).post<PostGeoDataFileProcessResponses, PostGeoDataFileProcessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file/{file_id}/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listGeoDataFileProcessingRun = <ThrowOnError extends boolean = false>(options: Options<ListGeoDataFileProcessingRunData, ThrowOnError>): RequestResult<ListGeoDataFileProcessingRunResponses, ListGeoDataFileProcessingRunErrors, ThrowOnError> => (options.client ?? client).get<ListGeoDataFileProcessingRunResponses, ListGeoDataFileProcessingRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file_processing_run',
    ...options
});

export const deleteGeoDataFileProcessingRun = <ThrowOnError extends boolean = false>(options: Options<DeleteGeoDataFileProcessingRunData, ThrowOnError>): RequestResult<DeleteGeoDataFileProcessingRunResponses, DeleteGeoDataFileProcessingRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteGeoDataFileProcessingRunResponses, DeleteGeoDataFileProcessingRunErrors, ThrowOnError>({ url: '/org/{org_id}/geo_data_file_processing_run/{run_id}', ...options });

/**
 * Fetch one processing run — its status, recorded options, and
 * `failure_reason` if it failed.
 *
 * This is the polling endpoint after `POST .../process`: the run advances
 * `pending` → `processing` → `processed` or `failed` on its own.
 */
export const getGeoDataFileProcessingRun = <ThrowOnError extends boolean = false>(options: Options<GetGeoDataFileProcessingRunData, ThrowOnError>): RequestResult<GetGeoDataFileProcessingRunResponses, GetGeoDataFileProcessingRunErrors, ThrowOnError> => (options.client ?? client).get<GetGeoDataFileProcessingRunResponses, GetGeoDataFileProcessingRunErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/geo_data_file_processing_run/{run_id}',
    ...options
});

export const listRegion = <ThrowOnError extends boolean = false>(options: Options<ListRegionData, ThrowOnError>): RequestResult<ListRegionResponses, ListRegionErrors, ThrowOnError> => (options.client ?? client).get<ListRegionResponses, ListRegionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region',
    ...options
});

/**
 * Compose a Region from a selection of one processing run's Subregions.
 *
 * Generates the three RegionAreas synchronously — the per-tier union of the
 * members. The new Region is *not* active: activation is setting
 * `rubi_org.region_id`, a deliberate separate step taken after QA has reviewed
 * the Region, its union and its Subregions' metadata together. Several
 * candidate Regions may exist for one org at once.
 */
export const postRegion = <ThrowOnError extends boolean = false>(options: Options<PostRegionData, ThrowOnError>): RequestResult<PostRegionResponses, PostRegionErrors, ThrowOnError> => (options.client ?? client).post<PostRegionResponses, PostRegionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch one tier of an org's active Region.
 */
export const getRegionActiveArea = <ThrowOnError extends boolean = false>(options: Options<GetRegionActiveAreaData, ThrowOnError>): RequestResult<GetRegionActiveAreaResponses, GetRegionActiveAreaErrors, ThrowOnError> => (options.client ?? client).get<GetRegionActiveAreaResponses, GetRegionActiveAreaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region/active/area/{tier}',
    ...options
});

export const deleteRegion = <ThrowOnError extends boolean = false>(options: Options<DeleteRegionData, ThrowOnError>): RequestResult<DeleteRegionResponses, DeleteRegionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRegionResponses, DeleteRegionErrors, ThrowOnError>({ url: '/org/{org_id}/region/{region_id}', ...options });

/**
 * Fetch one Region with its membership. No geometry — fetch a tier from
 * `/org/{org_id}/region/{region_id}/area/{tier}`.
 */
export const getRegion = <ThrowOnError extends boolean = false>(options: Options<GetRegionData, ThrowOnError>): RequestResult<GetRegionResponses, GetRegionErrors, ThrowOnError> => (options.client ?? client).get<GetRegionResponses, GetRegionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region/{region_id}',
    ...options
});

/**
 * Replace a Region's membership, regenerating its RegionAreas.
 */
export const patchRegion = <ThrowOnError extends boolean = false>(options: Options<PatchRegionData, ThrowOnError>): RequestResult<PatchRegionResponses, PatchRegionErrors, ThrowOnError> => (options.client ?? client).patch<PatchRegionResponses, PatchRegionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region/{region_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch one tier of a Region's union geometry.
 *
 * `full` is the authoritative union and can exceed 20 MB — it is what the
 * backend covers points with, but prefer `low` or `medium` for anything a
 * browser renders.
 */
export const getRegionArea = <ThrowOnError extends boolean = false>(options: Options<GetRegionAreaData, ThrowOnError>): RequestResult<GetRegionAreaResponses, GetRegionAreaErrors, ThrowOnError> => (options.client ?? client).get<GetRegionAreaResponses, GetRegionAreaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/region/{region_id}/area/{tier}',
    ...options
});

/**
 * List an Organization's Subregions, newest first. No geometry — fetch a
 * tier from `/org/{org_id}/subregion/{subregion_id}/area/{tier}`.
 */
export const listSubregion = <ThrowOnError extends boolean = false>(options: Options<ListSubregionData, ThrowOnError>): RequestResult<ListSubregionResponses, ListSubregionErrors, ThrowOnError> => (options.client ?? client).get<ListSubregionResponses, ListSubregionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/subregion',
    ...options
});

/**
 * Fetch one Subregion. No geometry — fetch a tier from
 * `/org/{org_id}/subregion/{subregion_id}/area/{tier}`.
 */
export const getSubregion = <ThrowOnError extends boolean = false>(options: Options<GetSubregionData, ThrowOnError>): RequestResult<GetSubregionResponses, GetSubregionErrors, ThrowOnError> => (options.client ?? client).get<GetSubregionResponses, GetSubregionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/subregion/{subregion_id}',
    ...options
});

export const patchSubregion = <ThrowOnError extends boolean = false>(options: Options<PatchSubregionData, ThrowOnError>): RequestResult<PatchSubregionResponses, PatchSubregionErrors, ThrowOnError> => (options.client ?? client).patch<PatchSubregionResponses, PatchSubregionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/subregion/{subregion_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch one tier of a Subregion's geometry.
 *
 * `full` is the authoritative upload and can exceed 20 MB — prefer `low` or
 * `medium` for anything but a debug view or a backend check.
 */
export const getSubregionArea = <ThrowOnError extends boolean = false>(options: Options<GetSubregionAreaData, ThrowOnError>): RequestResult<GetSubregionAreaResponses, GetSubregionAreaErrors, ThrowOnError> => (options.client ?? client).get<GetSubregionAreaResponses, GetSubregionAreaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org/{org_id}/subregion/{subregion_id}/area/{tier}',
    ...options
});

export const getOrgLookup = <ThrowOnError extends boolean = false>(options: Options<GetOrgLookupData, ThrowOnError>): RequestResult<GetOrgLookupResponses, GetOrgLookupErrors, ThrowOnError> => (options.client ?? client).get<GetOrgLookupResponses, GetOrgLookupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/org_lookup',
    ...options
});

export const postPartnerOrgBootstrap = <ThrowOnError extends boolean = false>(options: Options<PostPartnerOrgBootstrapData, ThrowOnError>): RequestResult<PostPartnerOrgBootstrapResponses, PostPartnerOrgBootstrapErrors, ThrowOnError> => (options.client ?? client).post<PostPartnerOrgBootstrapResponses, PostPartnerOrgBootstrapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/partner_org/bootstrap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPartnerOrg = <ThrowOnError extends boolean = false>(options: Options<GetPartnerOrgData, ThrowOnError>): RequestResult<GetPartnerOrgResponses, GetPartnerOrgErrors, ThrowOnError> => (options.client ?? client).get<GetPartnerOrgResponses, GetPartnerOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/partner_org/{partner_org_id}',
    ...options
});

export const patchPartnerOrg = <ThrowOnError extends boolean = false>(options: Options<PatchPartnerOrgData, ThrowOnError>): RequestResult<PatchPartnerOrgResponses, PatchPartnerOrgErrors, ThrowOnError> => (options.client ?? client).patch<PatchPartnerOrgResponses, PatchPartnerOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/partner_org/{partner_org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The `rubi_org` hosting a partner's staff login, if one has been created for it. A partner
 * org's own row never carries this link (deliberately separate, see `partner_org::Model`) — the
 * FK lives on `rubi_org.partner_org_id`, so this is a reverse lookup rather than a plain `get`.
 */
export const getPartnerOrgRubiOrg = <ThrowOnError extends boolean = false>(options: Options<GetPartnerOrgRubiOrgData, ThrowOnError>): RequestResult<GetPartnerOrgRubiOrgResponses, GetPartnerOrgRubiOrgErrors, ThrowOnError> => (options.client ?? client).get<GetPartnerOrgRubiOrgResponses, GetPartnerOrgRubiOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/partner_org/{partner_org_id}/rubi_org',
    ...options
});

export const listPermission = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionData, ThrowOnError>): RequestResult<ListPermissionResponses, ListPermissionErrors, ThrowOnError> => (options?.client ?? client).get<ListPermissionResponses, ListPermissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/permission',
    ...options
});

export const deletePermission = <ThrowOnError extends boolean = false>(options: Options<DeletePermissionData, ThrowOnError>): RequestResult<DeletePermissionResponses, DeletePermissionErrors, ThrowOnError> => (options.client ?? client).delete<DeletePermissionResponses, DeletePermissionErrors, ThrowOnError>({ url: '/permission/{permission_id}', ...options });

export const putPermission = <ThrowOnError extends boolean = false>(options: Options<PutPermissionData, ThrowOnError>): RequestResult<PutPermissionResponses, PutPermissionErrors, ThrowOnError> => (options.client ?? client).put<PutPermissionResponses, PutPermissionErrors, ThrowOnError>({
    url: '/permission/{permission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postPermissionAddUser = <ThrowOnError extends boolean = false>(options: Options<PostPermissionAddUserData, ThrowOnError>): RequestResult<PostPermissionAddUserResponses, PostPermissionAddUserErrors, ThrowOnError> => (options.client ?? client).post<PostPermissionAddUserResponses, PostPermissionAddUserErrors, ThrowOnError>({
    url: '/permission/{permission_id}/add_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postPermissionRemoveUser = <ThrowOnError extends boolean = false>(options: Options<PostPermissionRemoveUserData, ThrowOnError>): RequestResult<PostPermissionRemoveUserResponses, PostPermissionRemoveUserErrors, ThrowOnError> => (options.client ?? client).post<PostPermissionRemoveUserResponses, PostPermissionRemoveUserErrors, ThrowOnError>({
    url: '/permission/{permission_id}/remove_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listPermissionUser = <ThrowOnError extends boolean = false>(options: Options<ListPermissionUserData, ThrowOnError>): RequestResult<ListPermissionUserResponses, ListPermissionUserErrors, ThrowOnError> => (options.client ?? client).get<ListPermissionUserResponses, ListPermissionUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/permission/{permission_id}/user',
    ...options
});

export const postCopyOrganizationFormConfig = <ThrowOnError extends boolean = false>(options: Options<PostCopyOrganizationFormConfigData, ThrowOnError>): RequestResult<PostCopyOrganizationFormConfigResponses, PostCopyOrganizationFormConfigErrors, ThrowOnError> => (options.client ?? client).post<PostCopyOrganizationFormConfigResponses, PostCopyOrganizationFormConfigErrors, ThrowOnError>({ url: '/portal/admin/{source_organization_id}/copy_organization_form_config/{target_organization_id}', ...options });

export const listCommunityPublic = <ThrowOnError extends boolean = false>(options?: Options<ListCommunityPublicData, ThrowOnError>): RequestResult<ListCommunityPublicResponses, ListCommunityPublicErrors, ThrowOnError> => (options?.client ?? client).get<ListCommunityPublicResponses, ListCommunityPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/community',
    ...options
});

export const getCommunityPublic = <ThrowOnError extends boolean = false>(options: Options<GetCommunityPublicData, ThrowOnError>): RequestResult<GetCommunityPublicResponses, GetCommunityPublicErrors, ThrowOnError> => (options.client ?? client).get<GetCommunityPublicResponses, GetCommunityPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public/community/{id_or_slug}',
    ...options
});

/**
 * Update public account information
 *
 * This endpoint allows the authenticated user to update their profile information
 * and business location details. It can update both user and business information
 * in a single request.
 */
export const patchPublicAccount = <ThrowOnError extends boolean = false>(options: Options<PatchPublicAccountData, ThrowOnError>): RequestResult<PatchPublicAccountResponses, PatchPublicAccountErrors, ThrowOnError> => (options.client ?? client).patch<PatchPublicAccountResponses, PatchPublicAccountErrors, ThrowOnError>({
    responseType: 'json',
    url: '/public_account/{public_account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Every org's active Region at the `low` tier, for the services map.
 */
export const getRegionMap = <ThrowOnError extends boolean = false>(options?: Options<GetRegionMapData, ThrowOnError>): RequestResult<GetRegionMapResponses, GetRegionMapErrors, ThrowOnError> => (options?.client ?? client).get<GetRegionMapResponses, GetRegionMapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/region_map',
    ...options
});

/**
 * Create a modification token for a single registry submission
 * This is used when the user is on the modify-remove list page and wants to modify a single submission
 * Since when the user submits the survey, we expire the modification token related to that submission
 *
 * @deprecated
 */
export const postCreateSingleSubmissionModificationToken = <ThrowOnError extends boolean = false>(options: Options<PostCreateSingleSubmissionModificationTokenData, ThrowOnError>): RequestResult<PostCreateSingleSubmissionModificationTokenResponses, PostCreateSingleSubmissionModificationTokenErrors, ThrowOnError> => (options.client ?? client).post<PostCreateSingleSubmissionModificationTokenResponses, PostCreateSingleSubmissionModificationTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/registry/public/create_single_submission_modification_token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSendModifyRemoveRegistryTokenEmail = <ThrowOnError extends boolean = false>(options: Options<PostSendModifyRemoveRegistryTokenEmailData, ThrowOnError>): RequestResult<PostSendModifyRemoveRegistryTokenEmailResponses, PostSendModifyRemoveRegistryTokenEmailErrors, ThrowOnError> => (options.client ?? client).post<PostSendModifyRemoveRegistryTokenEmailResponses, PostSendModifyRemoveRegistryTokenEmailErrors, ThrowOnError>({
    url: '/registry/public/modify_remove_registry_token_email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRegistrySubmissionPublic = <ThrowOnError extends boolean = false>(options?: Options<ListRegistrySubmissionPublicData, ThrowOnError>): RequestResult<ListRegistrySubmissionPublicResponses, ListRegistrySubmissionPublicErrors, ThrowOnError> => (options?.client ?? client).get<ListRegistrySubmissionPublicResponses, ListRegistrySubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/registry/public/registry_submission',
    ...options
});

export const listSubmissionRegistry = <ThrowOnError extends boolean = false>(options: Options<ListSubmissionRegistryData, ThrowOnError>): RequestResult<ListSubmissionRegistryResponses, ListSubmissionRegistryErrors, ThrowOnError> => (options.client ?? client).get<ListSubmissionRegistryResponses, ListSubmissionRegistryErrors, ThrowOnError>({
    responseType: 'json',
    url: '/registry/submission',
    ...options
});

export const postSubmissionScheduleModificationRequestedJobs = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionScheduleModificationRequestedJobsData, ThrowOnError>): RequestResult<PostSubmissionScheduleModificationRequestedJobsResponses, PostSubmissionScheduleModificationRequestedJobsErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionScheduleModificationRequestedJobsResponses, PostSubmissionScheduleModificationRequestedJobsErrors, ThrowOnError>({ url: '/report/admin/submission/{submission_id}/schedule_modification_requested_jobs', ...options });

/**
 * @deprecated
 */
export const importSubmission = <ThrowOnError extends boolean = false>(options: Options<ImportSubmissionData2, ThrowOnError>): RequestResult<ImportSubmissionResponses, ImportSubmissionErrors, ThrowOnError> => (options.client ?? client).post<ImportSubmissionResponses, ImportSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/import/submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postItemTypeOption = <ThrowOnError extends boolean = false>(options: Options<PostItemTypeOptionData, ThrowOnError>): RequestResult<PostItemTypeOptionResponses, PostItemTypeOptionErrors, ThrowOnError> => (options.client ?? client).post<PostItemTypeOptionResponses, PostItemTypeOptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview a casing change for a dropdown list's labels.
 *
 * Stateless: rewrites only each item's `label` to the requested style and returns the
 * result without persisting. Values, codes, categories, and translations are unchanged.
 */
export const postItemTypeOptionRecasePreview = <ThrowOnError extends boolean = false>(options: Options<PostItemTypeOptionRecasePreviewData, ThrowOnError>): RequestResult<PostItemTypeOptionRecasePreviewResponses, PostItemTypeOptionRecasePreviewErrors, ThrowOnError> => (options.client ?? client).post<PostItemTypeOptionRecasePreviewResponses, PostItemTypeOptionRecasePreviewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option/recase-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteItemTypeOption = <ThrowOnError extends boolean = false>(options: Options<DeleteItemTypeOptionData, ThrowOnError>): RequestResult<DeleteItemTypeOptionResponses, DeleteItemTypeOptionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteItemTypeOptionResponses, DeleteItemTypeOptionErrors, ThrowOnError>({ url: '/report/item_type_option/{item_type_option_id}', ...options });

/**
 * Get an item type option by ID. Items are returned in v2 shape
 * (`{ version, items: [...] }`), converting legacy v1-stored data on the fly.
 */
export const getItemTypeOption = <ThrowOnError extends boolean = false>(options: Options<GetItemTypeOptionData, ThrowOnError>): RequestResult<GetItemTypeOptionResponses, GetItemTypeOptionErrors, ThrowOnError> => (options.client ?? client).get<GetItemTypeOptionResponses, GetItemTypeOptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option/{item_type_option_id}',
    ...options
});

export const putItemTypeOption = <ThrowOnError extends boolean = false>(options: Options<PutItemTypeOptionData, ThrowOnError>): RequestResult<PutItemTypeOptionResponses, PutItemTypeOptionErrors, ThrowOnError> => (options.client ?? client).put<PutItemTypeOptionResponses, PutItemTypeOptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option/{item_type_option_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postItemTypeOptionConvertV2 = <ThrowOnError extends boolean = false>(options: Options<PostItemTypeOptionConvertV2Data, ThrowOnError>): RequestResult<PostItemTypeOptionConvertV2Responses, PostItemTypeOptionConvertV2Errors, ThrowOnError> => (options.client ?? client).post<PostItemTypeOptionConvertV2Responses, PostItemTypeOptionConvertV2Errors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option/{item_type_option_id}/convert-to-v2',
    ...options
});

export const duplicateItemTypeOption = <ThrowOnError extends boolean = false>(options: Options<DuplicateItemTypeOptionData, ThrowOnError>): RequestResult<DuplicateItemTypeOptionResponses, DuplicateItemTypeOptionErrors, ThrowOnError> => (options.client ?? client).post<DuplicateItemTypeOptionResponses, DuplicateItemTypeOptionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/item_type_option/{item_type_option_id}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get items for a survey by item type option ID.
 * Supports format conversion for backwards compatibility.
 * - format=v1 (default): Returns legacy format (item_name, item_code, type_name, type_code)
 * - format=v2: Returns new format (label, value with categories)
 */
export const listOrgItemTypeOptionsLegacy = <ThrowOnError extends boolean = false>(options: Options<ListOrgItemTypeOptionsLegacyData, ThrowOnError>): RequestResult<ListOrgItemTypeOptionsLegacyResponses, ListOrgItemTypeOptionsLegacyErrors, ThrowOnError> => (options.client ?? client).get<ListOrgItemTypeOptionsLegacyResponses, ListOrgItemTypeOptionsLegacyErrors, ThrowOnError>({ url: '/report/items/{id}', ...options });

export const postBulkDeploy = <ThrowOnError extends boolean = false>(options: Options<PostBulkDeployData, ThrowOnError>): RequestResult<PostBulkDeployResponses, PostBulkDeployErrors, ThrowOnError> => (options.client ?? client).post<PostBulkDeployResponses, PostBulkDeployErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/bulk-deploy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postBulkEditApply = <ThrowOnError extends boolean = false>(options: Options<PostBulkEditApplyData, ThrowOnError>): RequestResult<PostBulkEditApplyResponses, PostBulkEditApplyErrors, ThrowOnError> => (options.client ?? client).post<PostBulkEditApplyResponses, PostBulkEditApplyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/bulk-edit/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postBulkEditPreview = <ThrowOnError extends boolean = false>(options: Options<PostBulkEditPreviewData, ThrowOnError>): RequestResult<PostBulkEditPreviewResponses, PostBulkEditPreviewErrors, ThrowOnError> => (options.client ?? client).post<PostBulkEditPreviewResponses, PostBulkEditPreviewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/bulk-edit/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postBulkEditSearch = <ThrowOnError extends boolean = false>(options: Options<PostBulkEditSearchData, ThrowOnError>): RequestResult<PostBulkEditSearchResponses, PostBulkEditSearchErrors, ThrowOnError> => (options.client ?? client).post<PostBulkEditSearchResponses, PostBulkEditSearchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/bulk-edit/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putCallLog = <ThrowOnError extends boolean = false>(options: Options<PutCallLogData, ThrowOnError>): RequestResult<PutCallLogResponses, PutCallLogErrors, ThrowOnError> => (options.client ?? client).put<PutCallLogResponses, PutCallLogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/call_log',
    ...options
});

export const patchCallLog = <ThrowOnError extends boolean = false>(options: Options<PatchCallLogData, ThrowOnError>): RequestResult<PatchCallLogResponses, PatchCallLogErrors, ThrowOnError> => (options.client ?? client).patch<PatchCallLogResponses, PatchCallLogErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/call_log/{call_log_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrgConfigPublic = <ThrowOnError extends boolean = false>(options: Options<GetOrgConfigPublicData, ThrowOnError>): RequestResult<GetOrgConfigPublicResponses, GetOrgConfigPublicErrors, ThrowOnError> => (options.client ?? client).get<GetOrgConfigPublicResponses, GetOrgConfigPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/config',
    ...options
});

export const updateSurvey = <ThrowOnError extends boolean = false>(options: Options<UpdateSurveyData, ThrowOnError>): RequestResult<UpdateSurveyResponses, UpdateSurveyErrors, ThrowOnError> => (options.client ?? client).post<UpdateSurveyResponses, UpdateSurveyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/config/update_survey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSurveyConfig = <ThrowOnError extends boolean = false>(options: Options<GetSurveyConfigData, ThrowOnError>): RequestResult<GetSurveyConfigResponses, GetSurveyConfigErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyConfigResponses, GetSurveyConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/config/{survey_class}',
    ...options
});

export const getOrgDrafts = <ThrowOnError extends boolean = false>(options: Options<GetOrgDraftsData, ThrowOnError>): RequestResult<GetOrgDraftsResponses, GetOrgDraftsErrors, ThrowOnError> => (options.client ?? client).get<GetOrgDraftsResponses, GetOrgDraftsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/drafts',
    ...options
});

/**
 * Apply a casing style to the labels of many dropdown lists at once and persist each.
 *
 * Each list is re-cased and saved independently and reported on individually, so one failure
 * (a legacy v1 list, or one owned by another org) does not abort the rest. Only item labels
 * are rewritten; values, codes, categories, and translations are untouched.
 */
export const postItemTypeOptionBulkRecase = <ThrowOnError extends boolean = false>(options: Options<PostItemTypeOptionBulkRecaseData, ThrowOnError>): RequestResult<PostItemTypeOptionBulkRecaseResponses, PostItemTypeOptionBulkRecaseErrors, ThrowOnError> => (options.client ?? client).post<PostItemTypeOptionBulkRecaseResponses, PostItemTypeOptionBulkRecaseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/item_type_option/bulk-recase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listOrgItemTypeOptions = <ThrowOnError extends boolean = false>(options: Options<ListOrgItemTypeOptionsData, ThrowOnError>): RequestResult<ListOrgItemTypeOptionsResponses, ListOrgItemTypeOptionsErrors, ThrowOnError> => (options.client ?? client).get<ListOrgItemTypeOptionsResponses, ListOrgItemTypeOptionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/item_type_options',
    ...options
});

/**
 * @deprecated
 */
export const listOrgSubmission = <ThrowOnError extends boolean = false>(options: Options<ListOrgSubmissionData, ThrowOnError>): RequestResult<ListOrgSubmissionResponses, ListOrgSubmissionErrors, ThrowOnError> => (options.client ?? client).get<ListOrgSubmissionResponses, ListOrgSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/submission',
    ...options
});

/**
 * @deprecated
 */
export const putSurvey = <ThrowOnError extends boolean = false>(options: Options<PutSurveyData, ThrowOnError>): RequestResult<PutSurveyResponses, PutSurveyErrors, ThrowOnError> => (options.client ?? client).put<PutSurveyResponses, PutSurveyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSurvey = <ThrowOnError extends boolean = false>(options: Options<DeleteSurveyData, ThrowOnError>): RequestResult<DeleteSurveyResponses, DeleteSurveyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSurveyResponses, DeleteSurveyErrors, ThrowOnError>({ url: '/report/org/{org_id}/survey/{parent_survey_id}', ...options });

export const getSurveyVersionCompare = <ThrowOnError extends boolean = false>(options: Options<GetSurveyVersionCompareData, ThrowOnError>): RequestResult<GetSurveyVersionCompareResponses, GetSurveyVersionCompareErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyVersionCompareResponses, GetSurveyVersionCompareErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/compare',
    ...options
});

export const getSurveyCurrentVersion = <ThrowOnError extends boolean = false>(options: Options<GetSurveyCurrentVersionData, ThrowOnError>): RequestResult<GetSurveyCurrentVersionResponses, GetSurveyCurrentVersionErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyCurrentVersionResponses, GetSurveyCurrentVersionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/current_version',
    ...options
});

export const deleteSurveyVersionDraft = <ThrowOnError extends boolean = false>(options: Options<DeleteSurveyVersionDraftData, ThrowOnError>): RequestResult<DeleteSurveyVersionDraftResponses, DeleteSurveyVersionDraftErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSurveyVersionDraftResponses, DeleteSurveyVersionDraftErrors, ThrowOnError>({ url: '/report/org/{org_id}/survey/{parent_survey_id}/draft', ...options });

export const getSurveyVersionDraft = <ThrowOnError extends boolean = false>(options: Options<GetSurveyVersionDraftData, ThrowOnError>): RequestResult<GetSurveyVersionDraftResponses, GetSurveyVersionDraftErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyVersionDraftResponses, GetSurveyVersionDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/draft',
    ...options
});

export const patchSurveyVersionDraft = <ThrowOnError extends boolean = false>(options: Options<PatchSurveyVersionDraftData, ThrowOnError>): RequestResult<PatchSurveyVersionDraftResponses, PatchSurveyVersionDraftErrors, ThrowOnError> => (options.client ?? client).patch<PatchSurveyVersionDraftResponses, PatchSurveyVersionDraftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSurveyVersionDeploy = <ThrowOnError extends boolean = false>(options: Options<PostSurveyVersionDeployData, ThrowOnError>): RequestResult<PostSurveyVersionDeployResponses, PostSurveyVersionDeployErrors, ThrowOnError> => (options.client ?? client).post<PostSurveyVersionDeployResponses, PostSurveyVersionDeployErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/draft/deploy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSurveyVersion = <ThrowOnError extends boolean = false>(options: Options<GetSurveyVersionData, ThrowOnError>): RequestResult<GetSurveyVersionResponses, GetSurveyVersionErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyVersionResponses, GetSurveyVersionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/version/{version_id}',
    ...options
});

export const postSurveyVersionRollback = <ThrowOnError extends boolean = false>(options: Options<PostSurveyVersionRollbackData, ThrowOnError>): RequestResult<PostSurveyVersionRollbackResponses, PostSurveyVersionRollbackErrors, ThrowOnError> => (options.client ?? client).post<PostSurveyVersionRollbackResponses, PostSurveyVersionRollbackErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/version/{version_id}/rollback',
    ...options
});

export const listSurveyVersions = <ThrowOnError extends boolean = false>(options: Options<ListSurveyVersionsData, ThrowOnError>): RequestResult<ListSurveyVersionsResponses, ListSurveyVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListSurveyVersionsResponses, ListSurveyVersionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{parent_survey_id}/versions',
    ...options
});

/**
 * Generate condensed report from survey draft configuration
 *
 * Creates a condensed single-page version of a multi-page survey by:
 * - Converting all pages into a single page
 * - Adding an administrative information panel
 * - Applying text capitalization and formatting
 * - Adding police service branding
 *
 * This endpoint operates on the DRAFT version of the survey. If no draft exists,
 * one will be created from the active version. The condensed report is saved to the
 * draft's `pdf_configuration` field, allowing preview before deployment.
 */
export const postSurveyCondensed = <ThrowOnError extends boolean = false>(options: Options<PostSurveyCondensedData, ThrowOnError>): RequestResult<PostSurveyCondensedResponses, PostSurveyCondensedErrors, ThrowOnError> => (options.client ?? client).post<PostSurveyCondensedResponses, PostSurveyCondensedErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey/{survey_id}/condensed',
    ...options
});

export const postOrgSurveyGroup = <ThrowOnError extends boolean = false>(options: Options<PostOrgSurveyGroupData, ThrowOnError>): RequestResult<PostOrgSurveyGroupResponses, PostOrgSurveyGroupErrors, ThrowOnError> => (options.client ?? client).post<PostOrgSurveyGroupResponses, PostOrgSurveyGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey_group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteOrgSurveyGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgSurveyGroupData, ThrowOnError>): RequestResult<DeleteOrgSurveyGroupResponses, DeleteOrgSurveyGroupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgSurveyGroupResponses, DeleteOrgSurveyGroupErrors, ThrowOnError>({ url: '/report/org/{org_id}/survey_group/{group_id}', ...options });

export const patchOrgSurveyGroup = <ThrowOnError extends boolean = false>(options: Options<PatchOrgSurveyGroupData, ThrowOnError>): RequestResult<PatchOrgSurveyGroupResponses, PatchOrgSurveyGroupErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrgSurveyGroupResponses, PatchOrgSurveyGroupErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey_group/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putSurveyGroupMemberships = <ThrowOnError extends boolean = false>(options: Options<PutSurveyGroupMembershipsData, ThrowOnError>): RequestResult<PutSurveyGroupMembershipsResponses, PutSurveyGroupMembershipsErrors, ThrowOnError> => (options.client ?? client).put<PutSurveyGroupMembershipsResponses, PutSurveyGroupMembershipsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey_group/{group_id}/memberships',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrgSurveyGroups = <ThrowOnError extends boolean = false>(options: Options<GetOrgSurveyGroupsData, ThrowOnError>): RequestResult<GetOrgSurveyGroupsResponses, GetOrgSurveyGroupsErrors, ThrowOnError> => (options.client ?? client).get<GetOrgSurveyGroupsResponses, GetOrgSurveyGroupsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey_groups',
    ...options
});

export const getOrgSurveyVersionOverview = <ThrowOnError extends boolean = false>(options: Options<GetOrgSurveyVersionOverviewData, ThrowOnError>): RequestResult<GetOrgSurveyVersionOverviewResponses, GetOrgSurveyVersionOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetOrgSurveyVersionOverviewResponses, GetOrgSurveyVersionOverviewErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/survey_version_overview',
    ...options
});

/**
 * @deprecated
 */
export const getOrgSurveys = <ThrowOnError extends boolean = false>(options: Options<GetOrgSurveysData, ThrowOnError>): RequestResult<GetOrgSurveysResponses, GetOrgSurveysErrors, ThrowOnError> => (options.client ?? client).get<GetOrgSurveysResponses, GetOrgSurveysErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/surveys',
    ...options
});

export const postSurveyCreate = <ThrowOnError extends boolean = false>(options: Options<PostSurveyCreateData, ThrowOnError>): RequestResult<PostSurveyCreateResponses, PostSurveyCreateErrors, ThrowOnError> => (options.client ?? client).post<PostSurveyCreateResponses, PostSurveyCreateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/surveys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteOrgTemplates = <ThrowOnError extends boolean = false>(options: Options<DeleteOrgTemplatesData, ThrowOnError>): RequestResult<DeleteOrgTemplatesResponses, DeleteOrgTemplatesErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrgTemplatesResponses, DeleteOrgTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrgTemplates = <ThrowOnError extends boolean = false>(options: Options<GetOrgTemplatesData, ThrowOnError>): RequestResult<GetOrgTemplatesResponses, GetOrgTemplatesErrors, ThrowOnError> => (options.client ?? client).get<GetOrgTemplatesResponses, GetOrgTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/template',
    ...options
});

export const patchOrgTemplates = <ThrowOnError extends boolean = false>(options: Options<PatchOrgTemplatesData, ThrowOnError>): RequestResult<PatchOrgTemplatesResponses, PatchOrgTemplatesErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrgTemplatesResponses, PatchOrgTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putOrgTemplates = <ThrowOnError extends boolean = false>(options: Options<PutOrgTemplatesData, ThrowOnError>): RequestResult<PutOrgTemplatesResponses, PutOrgTemplatesErrors, ThrowOnError> => (options.client ?? client).put<PutOrgTemplatesResponses, PutOrgTemplatesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrgUsers = <ThrowOnError extends boolean = false>(options: Options<GetOrgUsersData, ThrowOnError>): RequestResult<GetOrgUsersResponses, GetOrgUsersErrors, ThrowOnError> => (options.client ?? client).get<GetOrgUsersResponses, GetOrgUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/org/{org_id}/users',
    ...options
});

/**
 * Distinct agencies and report types across the partner's visible reports, to populate the list's
 * filter dropdowns. Same security scope as the list itself.
 */
export const getPartnerFilterOptions = <ThrowOnError extends boolean = false>(options?: Options<GetPartnerFilterOptionsData, ThrowOnError>): RequestResult<GetPartnerFilterOptionsResponses, GetPartnerFilterOptionsErrors, ThrowOnError> => (options?.client ?? client).get<GetPartnerFilterOptionsResponses, GetPartnerFilterOptionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/partner/filter_options',
    ...options
});

export const listSubmissionPartner = <ThrowOnError extends boolean = false>(options?: Options<ListSubmissionPartnerData, ThrowOnError>): RequestResult<ListSubmissionPartnerResponses, ListSubmissionPartnerErrors, ThrowOnError> => (options?.client ?? client).get<ListSubmissionPartnerResponses, ListSubmissionPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/partner/submission',
    ...options
});

export const getSubmissionPartner = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPartnerData, ThrowOnError>): RequestResult<GetSubmissionPartnerResponses, GetSubmissionPartnerErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPartnerResponses, GetSubmissionPartnerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/partner/submission/{submission_id}',
    ...options
});

export const getSubmissionPartnerPdf = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPartnerPdfData, ThrowOnError>): RequestResult<GetSubmissionPartnerPdfResponses, GetSubmissionPartnerPdfErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPartnerPdfResponses, GetSubmissionPartnerPdfErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/report/partner/submission/{submission_id}/pdf',
    ...options
});

/**
 * List the partner orgs a survey's submissions can be shared with. Internal-admin facing (the
 * form builder) — any authenticated portal user; titles only, no sensitive data.
 */
export const listPartnerOrg = <ThrowOnError extends boolean = false>(options?: Options<ListPartnerOrgData, ThrowOnError>): RequestResult<ListPartnerOrgResponses, ListPartnerOrgErrors, ThrowOnError> => (options?.client ?? client).get<ListPartnerOrgResponses, ListPartnerOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/partner_org',
    ...options
});

export const listIntelImageMatchByAttachment = <ThrowOnError extends boolean = false>(options: Options<ListIntelImageMatchByAttachmentData, ThrowOnError>): RequestResult<ListIntelImageMatchByAttachmentResponses, ListIntelImageMatchByAttachmentErrors, ThrowOnError> => (options.client ?? client).get<ListIntelImageMatchByAttachmentResponses, ListIntelImageMatchByAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/attachment/{attachment_id}/intel_image_matches',
    ...options
});

/**
 * @deprecated
 */
export const postBatchVectorizeAttachments = <ThrowOnError extends boolean = false>(options: Options<PostBatchVectorizeAttachmentsData, ThrowOnError>): RequestResult<PostBatchVectorizeAttachmentsResponses, PostBatchVectorizeAttachmentsErrors, ThrowOnError> => (options.client ?? client).post<PostBatchVectorizeAttachmentsResponses, PostBatchVectorizeAttachmentsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/batch_vectorize_attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postImageSearchPortal = <ThrowOnError extends boolean = false>(options: Options<PostImageSearchPortalData, ThrowOnError>): RequestResult<PostImageSearchPortalResponses, PostImageSearchPortalErrors, ThrowOnError> => (options.client ?? client).post<PostImageSearchPortalResponses, PostImageSearchPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/image_search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postIntelImageMatch = <ThrowOnError extends boolean = false>(options: Options<PostIntelImageMatchData, ThrowOnError>): RequestResult<PostIntelImageMatchResponses, PostIntelImageMatchErrors, ThrowOnError> => (options.client ?? client).post<PostIntelImageMatchResponses, PostIntelImageMatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/intel_image_match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteIntelImageMatch = <ThrowOnError extends boolean = false>(options: Options<DeleteIntelImageMatchData, ThrowOnError>): RequestResult<DeleteIntelImageMatchResponses, DeleteIntelImageMatchErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntelImageMatchResponses, DeleteIntelImageMatchErrors, ThrowOnError>({ url: '/report/portal/intel_image_match/{id}', ...options });

export const postIntelMatchReport = <ThrowOnError extends boolean = false>(options: Options<PostIntelMatchReportData, ThrowOnError>): RequestResult<PostIntelMatchReportResponses, PostIntelMatchReportErrors, ThrowOnError> => (options.client ?? client).post<PostIntelMatchReportResponses, PostIntelMatchReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/intel_match_report',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteIntelMatchReport = <ThrowOnError extends boolean = false>(options: Options<DeleteIntelMatchReportData, ThrowOnError>): RequestResult<DeleteIntelMatchReportResponses, DeleteIntelMatchReportErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntelMatchReportResponses, DeleteIntelMatchReportErrors, ThrowOnError>({ url: '/report/portal/intel_match_report/{id}', ...options });

export const getIntelMatchReport = <ThrowOnError extends boolean = false>(options: Options<GetIntelMatchReportData, ThrowOnError>): RequestResult<GetIntelMatchReportResponses, GetIntelMatchReportErrors, ThrowOnError> => (options.client ?? client).get<GetIntelMatchReportResponses, GetIntelMatchReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/intel_match_report/{id}',
    ...options
});

export const patchIntelMatchReport = <ThrowOnError extends boolean = false>(options: Options<PatchIntelMatchReportData, ThrowOnError>): RequestResult<PatchIntelMatchReportResponses, PatchIntelMatchReportErrors, ThrowOnError> => (options.client ?? client).patch<PatchIntelMatchReportResponses, PatchIntelMatchReportErrors, ThrowOnError>({
    url: '/report/portal/intel_match_report/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getIntelMatchReportPdf = <ThrowOnError extends boolean = false>(options: Options<GetIntelMatchReportPdfData, ThrowOnError>): RequestResult<GetIntelMatchReportPdfResponses, GetIntelMatchReportPdfErrors, ThrowOnError> => (options.client ?? client).get<GetIntelMatchReportPdfResponses, GetIntelMatchReportPdfErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/report/portal/intel_match_report/{id}/pdf',
    ...options
});

/**
 * Get the global linter schema configuration.
 *
 * This endpoint returns the current linter schema used for validating
 * survey field naming conventions. Requires `report_v2.write_as_org.` permission.
 */
export const getLinterSchema = <ThrowOnError extends boolean = false>(options?: Options<GetLinterSchemaData, ThrowOnError>): RequestResult<GetLinterSchemaResponses, GetLinterSchemaErrors, ThrowOnError> => (options?.client ?? client).get<GetLinterSchemaResponses, GetLinterSchemaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/linter/schema',
    ...options
});

/**
 * Update the global linter schema configuration.
 *
 * This endpoint replaces the entire linter schema. Requires `report_v2.write_as_org.`
 * permission. The version is automatically incremented.
 */
export const patchLinterSchema = <ThrowOnError extends boolean = false>(options: Options<PatchLinterSchemaData, ThrowOnError>): RequestResult<PatchLinterSchemaResponses, PatchLinterSchemaErrors, ThrowOnError> => (options.client ?? client).patch<PatchLinterSchemaResponses, PatchLinterSchemaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/linter/schema',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOrgConfigPortal = <ThrowOnError extends boolean = false>(options: Options<GetOrgConfigPortalData, ThrowOnError>): RequestResult<GetOrgConfigPortalResponses, GetOrgConfigPortalErrors, ThrowOnError> => (options.client ?? client).get<GetOrgConfigPortalResponses, GetOrgConfigPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/config',
    ...options
});

export const patchOrgConfig = <ThrowOnError extends boolean = false>(options: Options<PatchOrgConfigData, ThrowOnError>): RequestResult<PatchOrgConfigResponses, PatchOrgConfigErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrgConfigResponses, PatchOrgConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchOrgConfigAdmin = <ThrowOnError extends boolean = false>(options: Options<PatchOrgConfigAdminData, ThrowOnError>): RequestResult<PatchOrgConfigAdminResponses, PatchOrgConfigAdminErrors, ThrowOnError> => (options.client ?? client).patch<PatchOrgConfigAdminResponses, PatchOrgConfigAdminErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/config/admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postCrimeCode = <ThrowOnError extends boolean = false>(options: Options<PostCrimeCodeData, ThrowOnError>): RequestResult<PostCrimeCodeResponses, PostCrimeCodeErrors, ThrowOnError> => (options.client ?? client).post<PostCrimeCodeResponses, PostCrimeCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCrimeCode = <ThrowOnError extends boolean = false>(options: Options<GetCrimeCodeData, ThrowOnError>): RequestResult<GetCrimeCodeResponses, GetCrimeCodeErrors, ThrowOnError> => (options.client ?? client).get<GetCrimeCodeResponses, GetCrimeCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}',
    ...options
});

export const patchCrimeCode = <ThrowOnError extends boolean = false>(options: Options<PatchCrimeCodeData, ThrowOnError>): RequestResult<PatchCrimeCodeResponses, PatchCrimeCodeErrors, ThrowOnError> => (options.client ?? client).patch<PatchCrimeCodeResponses, PatchCrimeCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postCrimeCodeArchive = <ThrowOnError extends boolean = false>(options: Options<PostCrimeCodeArchiveData, ThrowOnError>): RequestResult<PostCrimeCodeArchiveResponses, PostCrimeCodeArchiveErrors, ThrowOnError> => (options.client ?? client).post<PostCrimeCodeArchiveResponses, PostCrimeCodeArchiveErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}/archive',
    ...options
});

export const getCrimeCodeRules = <ThrowOnError extends boolean = false>(options: Options<GetCrimeCodeRulesData, ThrowOnError>): RequestResult<GetCrimeCodeRulesResponses, GetCrimeCodeRulesErrors, ThrowOnError> => (options.client ?? client).get<GetCrimeCodeRulesResponses, GetCrimeCodeRulesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}/rules',
    ...options
});

export const postCrimeCodeRule = <ThrowOnError extends boolean = false>(options: Options<PostCrimeCodeRuleData, ThrowOnError>): RequestResult<PostCrimeCodeRuleResponses, PostCrimeCodeRuleErrors, ThrowOnError> => (options.client ?? client).post<PostCrimeCodeRuleResponses, PostCrimeCodeRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}/rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchCrimeCodeRule = <ThrowOnError extends boolean = false>(options: Options<PatchCrimeCodeRuleData, ThrowOnError>): RequestResult<PatchCrimeCodeRuleResponses, PatchCrimeCodeRuleErrors, ThrowOnError> => (options.client ?? client).patch<PatchCrimeCodeRuleResponses, PatchCrimeCodeRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_code/{crime_code_id}/rules/{rule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCrimeCodes = <ThrowOnError extends boolean = false>(options: Options<GetCrimeCodesData, ThrowOnError>): RequestResult<GetCrimeCodesResponses, GetCrimeCodesErrors, ThrowOnError> => (options.client ?? client).get<GetCrimeCodesResponses, GetCrimeCodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/crime_codes',
    ...options
});

export const deleteCrimeCodeRule = <ThrowOnError extends boolean = false>(options: Options<DeleteCrimeCodeRuleData, ThrowOnError>): RequestResult<DeleteCrimeCodeRuleResponses, DeleteCrimeCodeRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCrimeCodeRuleResponses, DeleteCrimeCodeRuleErrors, ThrowOnError>({ url: '/report/portal/org/{org_id}/crime_codes/{crime_code_id}/rules/{rule_id}', ...options });

export const listIntelMatchReport = <ThrowOnError extends boolean = false>(options: Options<ListIntelMatchReportData, ThrowOnError>): RequestResult<ListIntelMatchReportResponses, ListIntelMatchReportErrors, ThrowOnError> => (options.client ?? client).get<ListIntelMatchReportResponses, ListIntelMatchReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/intel_match_reports',
    ...options
});

/**
 * Admin-only: pull this org's Mark43 offense codes into `rv2_crime_code`.
 *
 * Enqueues a job rather than importing inline — a full pull is ~458 sequential Mark43
 * requests (their `pageSize` caps at 50) and takes about five minutes, well past any
 * sensible request timeout.
 *
 * Safe to re-run. The import matches existing rows on `(rubi_org_id, rms_code)` and
 * upserts, leaves archived rows alone, and never deletes: codes in Rubicon that Mark43
 * no longer returns are kept, since an agency may maintain codes the RMS never had.
 *
 * Expected to run rarely — once per agency at onboarding, then again when the
 * department reconfigures its codes.
 */
export const postOrgImportMark43CrimeCodes = <ThrowOnError extends boolean = false>(options: Options<PostOrgImportMark43CrimeCodesData, ThrowOnError>): RequestResult<PostOrgImportMark43CrimeCodesResponses, PostOrgImportMark43CrimeCodesErrors, ThrowOnError> => (options.client ?? client).post<PostOrgImportMark43CrimeCodesResponses, PostOrgImportMark43CrimeCodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/mark43/import_crime_codes',
    ...options
});

/**
 * Admin-only: pull this org's Mark43 property attribute lists into
 * `rv2_item_type_option`, one `Mark43: <type>` list per attribute type.
 *
 * Enqueues a job: the vehicle and firearm make lists alone are ~230 sequential
 * Mark43 requests (their `pageSize` caps at 50).
 *
 * Safe to re-run. Lists are matched by name and refreshed in place, keeping the
 * label and translations of every code they already held; codes Mark43 no longer has
 * enabled are removed.
 */
export const postOrgImportMark43ItemLists = <ThrowOnError extends boolean = false>(options: Options<PostOrgImportMark43ItemListsData, ThrowOnError>): RequestResult<PostOrgImportMark43ItemListsResponses, PostOrgImportMark43ItemListsErrors, ThrowOnError> => (options.client ?? client).post<PostOrgImportMark43ItemListsResponses, PostOrgImportMark43ItemListsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/mark43/import_item_lists',
    ...options
});

export const listNotificationRule = <ThrowOnError extends boolean = false>(options: Options<ListNotificationRuleData, ThrowOnError>): RequestResult<ListNotificationRuleResponses, ListNotificationRuleErrors, ThrowOnError> => (options.client ?? client).get<ListNotificationRuleResponses, ListNotificationRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/notification_rule',
    ...options
});

export const postNotificationRule = <ThrowOnError extends boolean = false>(options: Options<PostNotificationRuleData, ThrowOnError>): RequestResult<PostNotificationRuleResponses, PostNotificationRuleErrors, ThrowOnError> => (options.client ?? client).post<PostNotificationRuleResponses, PostNotificationRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/notification_rule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteNotificationRule = <ThrowOnError extends boolean = false>(options: Options<DeleteNotificationRuleData, ThrowOnError>): RequestResult<DeleteNotificationRuleResponses, DeleteNotificationRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNotificationRuleResponses, DeleteNotificationRuleErrors, ThrowOnError>({ url: '/report/portal/org/{org_id}/notification_rule/{rule_id}', ...options });

export const patchNotificationRule = <ThrowOnError extends boolean = false>(options: Options<PatchNotificationRuleData, ThrowOnError>): RequestResult<PatchNotificationRuleResponses, PatchNotificationRuleErrors, ThrowOnError> => (options.client ?? client).patch<PatchNotificationRuleResponses, PatchNotificationRuleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/notification_rule/{rule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putSubmissionPortal = <ThrowOnError extends boolean = false>(options: Options<PutSubmissionPortalData, ThrowOnError>): RequestResult<PutSubmissionPortalResponses, PutSubmissionPortalErrors, ThrowOnError> => (options.client ?? client).put<PutSubmissionPortalResponses, PutSubmissionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionCrimeCodes = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionCrimeCodesData, ThrowOnError>): RequestResult<GetSubmissionCrimeCodesResponses, GetSubmissionCrimeCodesErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionCrimeCodesResponses, GetSubmissionCrimeCodesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/submissions/{submission_id}/crime_codes',
    ...options
});

export const postSubmissionCrimeCode = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionCrimeCodeData, ThrowOnError>): RequestResult<PostSubmissionCrimeCodeResponses, PostSubmissionCrimeCodeErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionCrimeCodeResponses, PostSubmissionCrimeCodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/submissions/{submission_id}/crime_codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSubmissionCrimeCode = <ThrowOnError extends boolean = false>(options: Options<DeleteSubmissionCrimeCodeData, ThrowOnError>): RequestResult<DeleteSubmissionCrimeCodeResponses, DeleteSubmissionCrimeCodeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubmissionCrimeCodeResponses, DeleteSubmissionCrimeCodeErrors, ThrowOnError>({ url: '/report/portal/org/{org_id}/submissions/{submission_id}/crime_codes/{crime_code_id}', ...options });

export const getOrgSurveyConfigPortal = <ThrowOnError extends boolean = false>(options: Options<GetOrgSurveyConfigPortalData, ThrowOnError>): RequestResult<GetOrgSurveyConfigPortalResponses, GetOrgSurveyConfigPortalErrors, ThrowOnError> => (options.client ?? client).get<GetOrgSurveyConfigPortalResponses, GetOrgSurveyConfigPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/survey_config',
    ...options
});

export const postDeactivateSurveyConfig = <ThrowOnError extends boolean = false>(options: Options<PostDeactivateSurveyConfigData, ThrowOnError>): RequestResult<PostDeactivateSurveyConfigResponses, PostDeactivateSurveyConfigErrors, ThrowOnError> => (options.client ?? client).post<PostDeactivateSurveyConfigResponses, PostDeactivateSurveyConfigErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/survey_config/{config_id}/deactivate',
    ...options
});

export const deleteUserSurveyAccess = <ThrowOnError extends boolean = false>(options: Options<DeleteUserSurveyAccessData, ThrowOnError>): RequestResult<DeleteUserSurveyAccessResponses, DeleteUserSurveyAccessErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserSurveyAccessResponses, DeleteUserSurveyAccessErrors, ThrowOnError>({ url: '/report/portal/org/{org_id}/user/{user_id}/survey_access', ...options });

export const getUserSurveyAccess = <ThrowOnError extends boolean = false>(options: Options<GetUserSurveyAccessData, ThrowOnError>): RequestResult<GetUserSurveyAccessResponses, GetUserSurveyAccessErrors, ThrowOnError> => (options.client ?? client).get<GetUserSurveyAccessResponses, GetUserSurveyAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/user/{user_id}/survey_access',
    ...options
});

export const putUserSurveyAccess = <ThrowOnError extends boolean = false>(options: Options<PutUserSurveyAccessData, ThrowOnError>): RequestResult<PutUserSurveyAccessResponses, PutUserSurveyAccessErrors, ThrowOnError> => (options.client ?? client).put<PutUserSurveyAccessResponses, PutUserSurveyAccessErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/org/{org_id}/user/{user_id}/survey_access',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRmsExportError = <ThrowOnError extends boolean = false>(options?: Options<ListRmsExportErrorData, ThrowOnError>): RequestResult<ListRmsExportErrorResponses, ListRmsExportErrorErrors, ThrowOnError> => (options?.client ?? client).get<ListRmsExportErrorResponses, ListRmsExportErrorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/rms_export_error',
    ...options
});

export const getRmsExportError = <ThrowOnError extends boolean = false>(options: Options<GetRmsExportErrorData, ThrowOnError>): RequestResult<GetRmsExportErrorResponses, GetRmsExportErrorErrors, ThrowOnError> => (options.client ?? client).get<GetRmsExportErrorResponses, GetRmsExportErrorErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/rms_export_error/{error_id}',
    ...options
});

export const postRmsExportErrorReexport = <ThrowOnError extends boolean = false>(options: Options<PostRmsExportErrorReexportData, ThrowOnError>): RequestResult<PostRmsExportErrorReexportResponses, PostRmsExportErrorReexportErrors, ThrowOnError> => (options.client ?? client).post<PostRmsExportErrorReexportResponses, PostRmsExportErrorReexportErrors, ThrowOnError>({ url: '/report/portal/rms_export_error/{error_id}/reexport', ...options });

export const patchRmsExportErrorSubmission = <ThrowOnError extends boolean = false>(options: Options<PatchRmsExportErrorSubmissionData, ThrowOnError>): RequestResult<PatchRmsExportErrorSubmissionResponses, PatchRmsExportErrorSubmissionErrors, ThrowOnError> => (options.client ?? client).patch<PatchRmsExportErrorSubmissionResponses, PatchRmsExportErrorSubmissionErrors, ThrowOnError>({
    url: '/report/portal/rms_export_error/{error_id}/submission_data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postRmsExportErrorTestExport = <ThrowOnError extends boolean = false>(options: Options<PostRmsExportErrorTestExportData, ThrowOnError>): RequestResult<PostRmsExportErrorTestExportResponses, PostRmsExportErrorTestExportErrors, ThrowOnError> => (options.client ?? client).post<PostRmsExportErrorTestExportResponses, PostRmsExportErrorTestExportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/rms_export_error/{error_id}/test_export',
    ...options
});

export const deleteSubmissionPortal = <ThrowOnError extends boolean = false>(options: Options<DeleteSubmissionPortalData, ThrowOnError>): RequestResult<DeleteSubmissionPortalResponses, DeleteSubmissionPortalErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubmissionPortalResponses, DeleteSubmissionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPortalData, ThrowOnError>): RequestResult<GetSubmissionPortalResponses, GetSubmissionPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPortalResponses, GetSubmissionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}',
    ...options
});

export const patchSubmissionPortal = <ThrowOnError extends boolean = false>(options: Options<PatchSubmissionPortalData, ThrowOnError>): RequestResult<PatchSubmissionPortalResponses, PatchSubmissionPortalErrors, ThrowOnError> => (options.client ?? client).patch<PatchSubmissionPortalResponses, PatchSubmissionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionAttachmentPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentPortalData, ThrowOnError>): RequestResult<PostSubmissionAttachmentPortalResponses, PostSubmissionAttachmentPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentPortalResponses, PostSubmissionAttachmentPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchSubmissionAttachment = <ThrowOnError extends boolean = false>(options: Options<PatchSubmissionAttachmentData, ThrowOnError>): RequestResult<PatchSubmissionAttachmentResponses, PatchSubmissionAttachmentErrors, ThrowOnError> => (options.client ?? client).patch<PatchSubmissionAttachmentResponses, PatchSubmissionAttachmentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionAttachmentDescriptionPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionAttachmentDescriptionPortalData, ThrowOnError>): RequestResult<GetSubmissionAttachmentDescriptionPortalResponses, GetSubmissionAttachmentDescriptionPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionAttachmentDescriptionPortalResponses, GetSubmissionAttachmentDescriptionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}/description',
    ...options
});

export const getDrugSubmissionAttachmentDescriptionPortal = <ThrowOnError extends boolean = false>(options: Options<GetDrugSubmissionAttachmentDescriptionPortalData, ThrowOnError>): RequestResult<GetDrugSubmissionAttachmentDescriptionPortalResponses, GetDrugSubmissionAttachmentDescriptionPortalErrors, ThrowOnError> => (options.client ?? client).get<GetDrugSubmissionAttachmentDescriptionPortalResponses, GetDrugSubmissionAttachmentDescriptionPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}/drug_description',
    ...options
});

export const postSubmissionAttachmentExportStatus = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentExportStatusData, ThrowOnError>): RequestResult<PostSubmissionAttachmentExportStatusResponses, PostSubmissionAttachmentExportStatusErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentExportStatusResponses, PostSubmissionAttachmentExportStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}/export_status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionAttachmentThumbnailPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentThumbnailPortalData, ThrowOnError>): RequestResult<PostSubmissionAttachmentThumbnailPortalResponses, PostSubmissionAttachmentThumbnailPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentThumbnailPortalResponses, PostSubmissionAttachmentThumbnailPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}/thumbnail',
    ...options
});

export const postSubmissionAttachmentVectorPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentVectorPortalData, ThrowOnError>): RequestResult<PostSubmissionAttachmentVectorPortalResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentVectorPortalResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/attachment/{attachment_id}/vector',
    ...options
});

export const getSubmissionAuditLogPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionAuditLogPortalData, ThrowOnError>): RequestResult<GetSubmissionAuditLogPortalResponses, GetSubmissionAuditLogPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionAuditLogPortalResponses, GetSubmissionAuditLogPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/audit_log',
    ...options
});

export const postSubmissionClearExportPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionClearExportPortalData, ThrowOnError>): RequestResult<PostSubmissionClearExportPortalResponses, PostSubmissionClearExportPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionClearExportPortalResponses, PostSubmissionClearExportPortalErrors, ThrowOnError>({ url: '/report/portal/submission/{submission_id}/clear_export', ...options });

export const postSubmissionCreateBulletinUrl = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionCreateBulletinUrlData, ThrowOnError>): RequestResult<PostSubmissionCreateBulletinUrlResponses, PostSubmissionCreateBulletinUrlErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionCreateBulletinUrlResponses, PostSubmissionCreateBulletinUrlErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/create_bulletin_url',
    ...options
});

export const getSubmissionVersionDiff = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionVersionDiffData, ThrowOnError>): RequestResult<GetSubmissionVersionDiffResponses, GetSubmissionVersionDiffErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionVersionDiffResponses, GetSubmissionVersionDiffErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/diff',
    ...options
});

export const postSubmissionExportEvidencePortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionExportEvidencePortalData, ThrowOnError>): RequestResult<PostSubmissionExportEvidencePortalResponses, PostSubmissionExportEvidencePortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionExportEvidencePortalResponses, PostSubmissionExportEvidencePortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/export_evidence',
    ...options
});

/**
 * Manually (re-)queue a Mark43 export.
 *
 * Unlike the Axon equivalent (`post_submission_export_evidence_portal`), which spawns
 * a detached `tokio` task, this enqueues the same scheduled job the approval path uses
 * — so a failure is recorded and retried rather than lost, and the idempotency guard
 * in `rv2_mark43_export` still applies. A submission already exported at this version
 * results in a job that no-ops.
 *
 * Scheduled a minute out rather than immediately: `insert_scheduled_job` warns below
 * four minutes, but a manual re-export is usually chasing a fixed configuration and
 * waiting five minutes to see the result is needlessly slow.
 */
export const postSubmissionExportMark43Portal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionExportMark43PortalData, ThrowOnError>): RequestResult<PostSubmissionExportMark43PortalResponses, PostSubmissionExportMark43PortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionExportMark43PortalResponses, PostSubmissionExportMark43PortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/export_mark43',
    ...options
});

export const postSubmissionGenerateIncidentPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionGenerateIncidentPortalData, ThrowOnError>): RequestResult<PostSubmissionGenerateIncidentPortalResponses, PostSubmissionGenerateIncidentPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionGenerateIncidentPortalResponses, PostSubmissionGenerateIncidentPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/generate_incident',
    ...options
});

export const getSubmissionSynopsisPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionSynopsisPortalData, ThrowOnError>): RequestResult<GetSubmissionSynopsisPortalResponses, GetSubmissionSynopsisPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionSynopsisPortalResponses, GetSubmissionSynopsisPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/generate_synopsis',
    ...options
});

export const postSubmissionGenerateThumbnailsPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionGenerateThumbnailsPortalData, ThrowOnError>): RequestResult<PostSubmissionGenerateThumbnailsPortalResponses, PostSubmissionGenerateThumbnailsPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionGenerateThumbnailsPortalResponses, PostSubmissionGenerateThumbnailsPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/generate_thumbnails',
    ...options
});

export const listIntelImageMatchBySubmission = <ThrowOnError extends boolean = false>(options: Options<ListIntelImageMatchBySubmissionData, ThrowOnError>): RequestResult<ListIntelImageMatchBySubmissionResponses, ListIntelImageMatchBySubmissionErrors, ThrowOnError> => (options.client ?? client).get<ListIntelImageMatchBySubmissionResponses, ListIntelImageMatchBySubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/intel_image_matches',
    ...options
});

export const getSubmissionPdfPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPdfPortalData, ThrowOnError>): RequestResult<GetSubmissionPdfPortalResponses, GetSubmissionPdfPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPdfPortalResponses, GetSubmissionPdfPortalErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/report/portal/submission/{submission_id}/pdf',
    ...options
});

export const postSubmissionShare = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionShareData, ThrowOnError>): RequestResult<PostSubmissionShareResponses, PostSubmissionShareErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionShareResponses, PostSubmissionShareErrors, ThrowOnError>({
    url: '/report/portal/submission/{submission_id}/share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionStatusPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionStatusPortalData, ThrowOnError>): RequestResult<PostSubmissionStatusPortalResponses, PostSubmissionStatusPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionStatusPortalResponses, PostSubmissionStatusPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionSupplementalStatus = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionSupplementalStatusData, ThrowOnError>): RequestResult<PostSubmissionSupplementalStatusResponses, PostSubmissionSupplementalStatusErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionSupplementalStatusResponses, PostSubmissionSupplementalStatusErrors, ThrowOnError>({
    url: '/report/portal/submission/{submission_id}/supplemental_status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionSynopsisVerifiedPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionSynopsisVerifiedPortalData, ThrowOnError>): RequestResult<PostSubmissionSynopsisVerifiedPortalResponses, PostSubmissionSynopsisVerifiedPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionSynopsisVerifiedPortalResponses, PostSubmissionSynopsisVerifiedPortalErrors, ThrowOnError>({ url: '/report/portal/submission/{submission_id}/synopsis_verified', ...options });

/**
 * Translate a report to English by detecting the source language and storing the translation
 */
export const patchTranslateReportToEnglish = <ThrowOnError extends boolean = false>(options: Options<PatchTranslateReportToEnglishData, ThrowOnError>): RequestResult<PatchTranslateReportToEnglishResponses, PatchTranslateReportToEnglishErrors, ThrowOnError> => (options.client ?? client).patch<PatchTranslateReportToEnglishResponses, PatchTranslateReportToEnglishErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/translate_to_english',
    ...options
});

export const postSubmissionUpdateNotificationPortal = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionUpdateNotificationPortalData, ThrowOnError>): RequestResult<PostSubmissionUpdateNotificationPortalResponses, PostSubmissionUpdateNotificationPortalErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionUpdateNotificationPortalResponses, PostSubmissionUpdateNotificationPortalErrors, ThrowOnError>({
    url: '/report/portal/submission/{submission_id}/update_notification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionViewers = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionViewersData, ThrowOnError>): RequestResult<GetSubmissionViewersResponses, GetSubmissionViewersErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionViewersResponses, GetSubmissionViewersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/viewers',
    ...options
});

export const deleteSubmissionViewingLeave = <ThrowOnError extends boolean = false>(options: Options<DeleteSubmissionViewingLeaveData, ThrowOnError>): RequestResult<DeleteSubmissionViewingLeaveResponses, DeleteSubmissionViewingLeaveErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubmissionViewingLeaveResponses, DeleteSubmissionViewingLeaveErrors, ThrowOnError>({ url: '/report/portal/submission/{submission_id}/viewing', ...options });

export const patchSubmissionViewingEditing = <ThrowOnError extends boolean = false>(options: Options<PatchSubmissionViewingEditingData, ThrowOnError>): RequestResult<PatchSubmissionViewingEditingResponses, PatchSubmissionViewingEditingErrors, ThrowOnError> => (options.client ?? client).patch<PatchSubmissionViewingEditingResponses, PatchSubmissionViewingEditingErrors, ThrowOnError>({
    url: '/report/portal/submission/{submission_id}/viewing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionViewingJoin = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionViewingJoinData, ThrowOnError>): RequestResult<PostSubmissionViewingJoinResponses, PostSubmissionViewingJoinErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionViewingJoinResponses, PostSubmissionViewingJoinErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/viewing',
    ...options
});

export const getSubmissionXmlGenerationTestPortal = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionXmlGenerationTestPortalData, ThrowOnError>): RequestResult<GetSubmissionXmlGenerationTestPortalResponses, GetSubmissionXmlGenerationTestPortalErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionXmlGenerationTestPortalResponses, GetSubmissionXmlGenerationTestPortalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/submission/{submission_id}/xml_generation_test',
    ...options
});

export const getSurveyTranslations = <ThrowOnError extends boolean = false>(options: Options<GetSurveyTranslationsData, ThrowOnError>): RequestResult<GetSurveyTranslationsResponses, GetSurveyTranslationsErrors, ThrowOnError> => (options.client ?? client).post<GetSurveyTranslationsResponses, GetSurveyTranslationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/portal/survey/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCheckStatusEligibleSubmissionsPublic = <ThrowOnError extends boolean = false>(options?: Options<GetCheckStatusEligibleSubmissionsPublicData, ThrowOnError>): RequestResult<GetCheckStatusEligibleSubmissionsPublicResponses, GetCheckStatusEligibleSubmissionsPublicErrors, ThrowOnError> => (options?.client ?? client).get<GetCheckStatusEligibleSubmissionsPublicResponses, GetCheckStatusEligibleSubmissionsPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/check_status/eligible_submissions',
    ...options
});

export const postCheckStatusRequestPublic = <ThrowOnError extends boolean = false>(options: Options<PostCheckStatusRequestPublicData, ThrowOnError>): RequestResult<PostCheckStatusRequestPublicResponses, PostCheckStatusRequestPublicErrors, ThrowOnError> => (options.client ?? client).post<PostCheckStatusRequestPublicResponses, PostCheckStatusRequestPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/check_status/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCheckStatusSubmissionPublic = <ThrowOnError extends boolean = false>(options: Options<GetCheckStatusSubmissionPublicData, ThrowOnError>): RequestResult<GetCheckStatusSubmissionPublicResponses, GetCheckStatusSubmissionPublicErrors, ThrowOnError> => (options.client ?? client).get<GetCheckStatusSubmissionPublicResponses, GetCheckStatusSubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/check_status/submission/{submission_id}',
    ...options
});

export const postCheckStatusVerifyPublic = <ThrowOnError extends boolean = false>(options: Options<PostCheckStatusVerifyPublicData, ThrowOnError>): RequestResult<PostCheckStatusVerifyPublicResponses, PostCheckStatusVerifyPublicErrors, ThrowOnError> => (options.client ?? client).post<PostCheckStatusVerifyPublicResponses, PostCheckStatusVerifyPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/check_status/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postNarrativeFormCompletionPublic = <ThrowOnError extends boolean = false>(options: Options<PostNarrativeFormCompletionPublicData, ThrowOnError>): RequestResult<PostNarrativeFormCompletionPublicResponses, PostNarrativeFormCompletionPublicErrors, ThrowOnError> => (options.client ?? client).post<PostNarrativeFormCompletionPublicResponses, PostNarrativeFormCompletionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/narrative/form_completion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putSubmissionPublic = <ThrowOnError extends boolean = false>(options: Options<PutSubmissionPublicData, ThrowOnError>): RequestResult<PutSubmissionPublicResponses, PutSubmissionPublicErrors, ThrowOnError> => (options.client ?? client).put<PutSubmissionPublicResponses, PutSubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionConversation = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionConversationData, ThrowOnError>): RequestResult<PostSubmissionConversationResponses, PostSubmissionConversationErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionConversationResponses, PostSubmissionConversationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/conversation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resubscribeToDraftReminder = <ThrowOnError extends boolean = false>(options?: Options<ResubscribeToDraftReminderData, ThrowOnError>): RequestResult<ResubscribeToDraftReminderResponses, ResubscribeToDraftReminderErrors, ThrowOnError> => (options?.client ?? client).post<ResubscribeToDraftReminderResponses, ResubscribeToDraftReminderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/resubscribe_to_draft_reminder',
    ...options
});

export const unsubscribeFromDraftReminder = <ThrowOnError extends boolean = false>(options: Options<UnsubscribeFromDraftReminderData, ThrowOnError>): RequestResult<UnsubscribeFromDraftReminderResponses, UnsubscribeFromDraftReminderErrors, ThrowOnError> => (options.client ?? client).post<UnsubscribeFromDraftReminderResponses, UnsubscribeFromDraftReminderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/unsubscribe_draft_reminder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSubmissionPublic = <ThrowOnError extends boolean = false>(options: Options<DeleteSubmissionPublicData, ThrowOnError>): RequestResult<DeleteSubmissionPublicResponses, DeleteSubmissionPublicErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSubmissionPublicResponses, DeleteSubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionPublic = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPublicData, ThrowOnError>): RequestResult<GetSubmissionPublicResponses, GetSubmissionPublicErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPublicResponses, GetSubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}',
    ...options
});

export const patchSubmissionPublic = <ThrowOnError extends boolean = false>(options: Options<PatchSubmissionPublicData, ThrowOnError>): RequestResult<PatchSubmissionPublicResponses, PatchSubmissionPublicErrors, ThrowOnError> => (options.client ?? client).patch<PatchSubmissionPublicResponses, PatchSubmissionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionAttachmentPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentPublicData, ThrowOnError>): RequestResult<PostSubmissionAttachmentPublicResponses, PostSubmissionAttachmentPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentPublicResponses, PostSubmissionAttachmentPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionAttachmentDescriptionPublic = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionAttachmentDescriptionPublicData, ThrowOnError>): RequestResult<GetSubmissionAttachmentDescriptionPublicResponses, GetSubmissionAttachmentDescriptionPublicErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionAttachmentDescriptionPublicResponses, GetSubmissionAttachmentDescriptionPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/description',
    ...options
});

export const postSubmissionAttachmentOpenaiPdfAnalysis = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentOpenaiPdfAnalysisData, ThrowOnError>): RequestResult<PostSubmissionAttachmentOpenaiPdfAnalysisResponses, PostSubmissionAttachmentOpenaiPdfAnalysisErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentOpenaiPdfAnalysisResponses, PostSubmissionAttachmentOpenaiPdfAnalysisErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/openai_pdf_analysis',
    ...options
});

export const postSubmissionAttachmentOpenaiPdfAnalysisResponses = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentOpenaiPdfAnalysisResponsesData, ThrowOnError>): RequestResult<PostSubmissionAttachmentOpenaiPdfAnalysisResponsesResponses, PostSubmissionAttachmentOpenaiPdfAnalysisResponsesErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentOpenaiPdfAnalysisResponsesResponses, PostSubmissionAttachmentOpenaiPdfAnalysisResponsesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/openai_pdf_analysis_responses',
    ...options
});

export const postSubmissionAttachmentReleaseOrderAnalysisPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentReleaseOrderAnalysisPublicData, ThrowOnError>): RequestResult<PostSubmissionAttachmentReleaseOrderAnalysisPublicResponses, PostSubmissionAttachmentReleaseOrderAnalysisPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentReleaseOrderAnalysisPublicResponses, PostSubmissionAttachmentReleaseOrderAnalysisPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/release_order_analysis',
    ...options
});

export const postSubmissionAttachmentThumbnailPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentThumbnailPublicData, ThrowOnError>): RequestResult<PostSubmissionAttachmentThumbnailPublicResponses, PostSubmissionAttachmentThumbnailPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentThumbnailPublicResponses, PostSubmissionAttachmentThumbnailPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/thumbnail',
    ...options
});

export const postSubmissionAttachmentVectorPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionAttachmentVectorPublicData, ThrowOnError>): RequestResult<PostSubmissionAttachmentVectorPublicResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostSubmissionAttachmentVectorPublicResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/attachment/{attachment_id}/vector',
    ...options
});

export const postSubmissionBreachStatementPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionBreachStatementPublicData, ThrowOnError>): RequestResult<PostSubmissionBreachStatementPublicResponses, PostSubmissionBreachStatementPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionBreachStatementPublicResponses, PostSubmissionBreachStatementPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/breach_statement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolves AI-extracted plain-text values against the live, client-resolved choice lists of
 * a survey's dropdown-style questions. The caller (services frontend) sends each unresolved
 * field's proposed text plus its candidate options; the model returns the best-matching
 * candidate index per field so the frontend can select the exact choice value locally. This
 * is needed because `webServiceUrl`-backed choices only resolve in the browser, so they
 * can't be matched during the initial server-side PDF extraction.
 */
export const postSubmissionChoiceMatchPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionChoiceMatchPublicData, ThrowOnError>): RequestResult<PostSubmissionChoiceMatchPublicResponses, PostSubmissionChoiceMatchPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionChoiceMatchPublicResponses, PostSubmissionChoiceMatchPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/choice_match',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionDetectLanguagePublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionDetectLanguagePublicData, ThrowOnError>): RequestResult<PostSubmissionDetectLanguagePublicResponses, PostSubmissionDetectLanguagePublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionDetectLanguagePublicResponses, PostSubmissionDetectLanguagePublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/detect_language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postGenerateNarrativeFromSurveyJson = <ThrowOnError extends boolean = false>(options: Options<PostGenerateNarrativeFromSurveyJsonData, ThrowOnError>): RequestResult<PostGenerateNarrativeFromSurveyJsonResponses, PostGenerateNarrativeFromSurveyJsonErrors, ThrowOnError> => (options.client ?? client).post<PostGenerateNarrativeFromSurveyJsonResponses, PostGenerateNarrativeFromSurveyJsonErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/generate_narrative_from_survey',
    ...options
});

export const postSubmissionOneDayModificationToken = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionOneDayModificationTokenData, ThrowOnError>): RequestResult<PostSubmissionOneDayModificationTokenResponses, PostSubmissionOneDayModificationTokenErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionOneDayModificationTokenResponses, PostSubmissionOneDayModificationTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/one_day_modification_token',
    ...options
});

export const getSubmissionPdfPublic = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionPdfPublicData, ThrowOnError>): RequestResult<GetSubmissionPdfPublicResponses, GetSubmissionPdfPublicErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionPdfPublicResponses, GetSubmissionPdfPublicErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/report/public/submission/{submission_id}/pdf',
    ...options
});

export const getSubmissionRecommendedSurveyClassesPublic = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionRecommendedSurveyClassesPublicData, ThrowOnError>): RequestResult<GetSubmissionRecommendedSurveyClassesPublicResponses, GetSubmissionRecommendedSurveyClassesPublicErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionRecommendedSurveyClassesPublicResponses, GetSubmissionRecommendedSurveyClassesPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/recommended_survey_classes',
    ...options
});

export const postSubmissionSendInitialLink = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionSendInitialLinkData, ThrowOnError>): RequestResult<PostSubmissionSendInitialLinkResponses, PostSubmissionSendInitialLinkErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionSendInitialLinkResponses, PostSubmissionSendInitialLinkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/send_initial_link/{locale}',
    ...options
});

export const postSubmissionStatusPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionStatusPublicData, ThrowOnError>): RequestResult<PostSubmissionStatusPublicResponses, PostSubmissionStatusPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionStatusPublicResponses, PostSubmissionStatusPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postSubmissionValidateOrSendModificationLink = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionValidateOrSendModificationLinkData, ThrowOnError>): RequestResult<PostSubmissionValidateOrSendModificationLinkResponses, PostSubmissionValidateOrSendModificationLinkErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionValidateOrSendModificationLinkResponses, PostSubmissionValidateOrSendModificationLinkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/validate_or_send_modification_link',
    ...options
});

export const postSubmissionValidateOrSendRecoveryLink = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionValidateOrSendRecoveryLinkData, ThrowOnError>): RequestResult<PostSubmissionValidateOrSendRecoveryLinkResponses, PostSubmissionValidateOrSendRecoveryLinkErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionValidateOrSendRecoveryLinkResponses, PostSubmissionValidateOrSendRecoveryLinkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission/{submission_id}/validate_or_send_recovery_link',
    ...options
});

export const getSubmissionModifyListPublic = <ThrowOnError extends boolean = false>(options?: Options<GetSubmissionModifyListPublicData, ThrowOnError>): RequestResult<GetSubmissionModifyListPublicResponses, GetSubmissionModifyListPublicErrors, ThrowOnError> => (options?.client ?? client).get<GetSubmissionModifyListPublicResponses, GetSubmissionModifyListPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission_modify_list',
    ...options
});

export const postSubmissionModifyRequestPublic = <ThrowOnError extends boolean = false>(options: Options<PostSubmissionModifyRequestPublicData, ThrowOnError>): RequestResult<PostSubmissionModifyRequestPublicResponses, PostSubmissionModifyRequestPublicErrors, ThrowOnError> => (options.client ?? client).post<PostSubmissionModifyRequestPublicResponses, PostSubmissionModifyRequestPublicErrors, ThrowOnError>({
    url: '/report/public/submission_modify_request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubmissionSupplementalCarryOverPublic = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionSupplementalCarryOverPublicData, ThrowOnError>): RequestResult<GetSubmissionSupplementalCarryOverPublicResponses, GetSubmissionSupplementalCarryOverPublicErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionSupplementalCarryOverPublicResponses, GetSubmissionSupplementalCarryOverPublicErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/public/submission_supplemental_carry_over',
    ...options
});

export const getReportSuggestion = <ThrowOnError extends boolean = false>(options: Options<GetReportSuggestionData, ThrowOnError>): RequestResult<GetReportSuggestionResponses, GetReportSuggestionErrors, ThrowOnError> => (options.client ?? client).post<GetReportSuggestionResponses, GetReportSuggestionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/report_suggestion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendReferralLink = <ThrowOnError extends boolean = false>(options: Options<SendReferralLinkData, ThrowOnError>): RequestResult<SendReferralLinkResponses, SendReferralLinkErrors, ThrowOnError> => (options.client ?? client).post<SendReferralLinkResponses, SendReferralLinkErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/send_referral_link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listSharedItemTypeOptions = <ThrowOnError extends boolean = false>(options?: Options<ListSharedItemTypeOptionsData, ThrowOnError>): RequestResult<ListSharedItemTypeOptionsResponses, ListSharedItemTypeOptionsErrors, ThrowOnError> => (options?.client ?? client).get<ListSharedItemTypeOptionsResponses, ListSharedItemTypeOptionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/shared/item_type_options',
    ...options
});

export const listSubmissionReport = <ThrowOnError extends boolean = false>(options: Options<ListSubmissionReportData, ThrowOnError>): RequestResult<ListSubmissionReportResponses, ListSubmissionReportErrors, ThrowOnError> => (options.client ?? client).get<ListSubmissionReportResponses, ListSubmissionReportErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/submission',
    ...options
});

export const getSubmissionAssignableUsers = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionAssignableUsersData, ThrowOnError>): RequestResult<GetSubmissionAssignableUsersResponses, GetSubmissionAssignableUsersErrors, ThrowOnError> => (options.client ?? client).get<GetSubmissionAssignableUsersResponses, GetSubmissionAssignableUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/submission/{submission_id}/assignable_users',
    ...options
});

export const getSurvey = <ThrowOnError extends boolean = false>(options: Options<GetSurveyData, ThrowOnError>): RequestResult<GetSurveyResponses, GetSurveyErrors, ThrowOnError> => (options.client ?? client).get<GetSurveyResponses, GetSurveyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/survey/{survey_id}',
    ...options
});

/**
 * Export a SurveyJS survey definition as a Markdown summary or PDF.
 *
 * Loads the given survey version's configuration from the database and returns
 * a per-page summary of its questions (type, options, and visibility
 * triggers). The `Accept` header selects the output — `application/pdf`
 * (default) or `text/markdown`; the PDF is the same content rendered to a
 * document.
 */
export const postSurveyExport = <ThrowOnError extends boolean = false>(options: Options<PostSurveyExportData, ThrowOnError>): RequestResult<PostSurveyExportResponses, PostSurveyExportErrors, ThrowOnError> => (options.client ?? client).post<PostSurveyExportResponses, PostSurveyExportErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/report/survey/{version_id}/export',
    ...options
});

export const getSurveyNames = <ThrowOnError extends boolean = false>(options?: Options<GetSurveyNamesData, ThrowOnError>): RequestResult<GetSurveyNamesResponses, GetSurveyNamesErrors, ThrowOnError> => (options?.client ?? client).get<GetSurveyNamesResponses, GetSurveyNamesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/survey_names',
    ...options
});

export const postTranslateAllNameDescriptionSurveyFields = <ThrowOnError extends boolean = false>(options: Options<PostTranslateAllNameDescriptionSurveyFieldsData, ThrowOnError>): RequestResult<PostTranslateAllNameDescriptionSurveyFieldsResponses, PostTranslateAllNameDescriptionSurveyFieldsErrors, ThrowOnError> => (options.client ?? client).post<PostTranslateAllNameDescriptionSurveyFieldsResponses, PostTranslateAllNameDescriptionSurveyFieldsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/report/translate-all-surveys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putUserRv2 = <ThrowOnError extends boolean = false>(options: Options<PutUserRv2Data, ThrowOnError>): RequestResult<PutUserRv2Responses, PutUserRv2Errors, ThrowOnError> => (options.client ?? client).put<PutUserRv2Responses, PutUserRv2Errors, ThrowOnError>({
    url: '/report/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putUserRegistry = <ThrowOnError extends boolean = false>(options: Options<PutUserRegistryData, ThrowOnError>): RequestResult<PutUserRegistryResponses, PutUserRegistryErrors, ThrowOnError> => (options.client ?? client).put<PutUserRegistryResponses, PutUserRegistryErrors, ThrowOnError>({
    url: '/report/user_registry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listSubmissionRequest = <ThrowOnError extends boolean = false>(options: Options<ListSubmissionRequestData, ThrowOnError>): RequestResult<ListSubmissionRequestResponses, ListSubmissionRequestErrors, ThrowOnError> => (options.client ?? client).get<ListSubmissionRequestResponses, ListSubmissionRequestErrors, ThrowOnError>({
    responseType: 'json',
    url: '/request/submission',
    ...options
});

export const listScheduledJob = <ThrowOnError extends boolean = false>(options?: Options<ListScheduledJobData, ThrowOnError>): RequestResult<ListScheduledJobResponses, ListScheduledJobErrors, ThrowOnError> => (options?.client ?? client).get<ListScheduledJobResponses, ListScheduledJobErrors, ThrowOnError>({
    responseType: 'json',
    url: '/scheduled_job',
    ...options
});

export const postSms = <ThrowOnError extends boolean = false>(options: Options<PostSmsData, ThrowOnError>): RequestResult<unknown, PostSmsErrors, ThrowOnError> => (options.client ?? client).post<unknown, PostSmsErrors, ThrowOnError>({
    url: '/sms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteSsoConnection = <ThrowOnError extends boolean = false>(options: Options<DeleteSsoConnectionData, ThrowOnError>): RequestResult<DeleteSsoConnectionResponses, DeleteSsoConnectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSsoConnectionResponses, DeleteSsoConnectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/connection/{connection_id}',
    ...options
});

export const listSsoConnections = <ThrowOnError extends boolean = false>(options: Options<ListSsoConnectionsData, ThrowOnError>): RequestResult<ListSsoConnectionsResponses, ListSsoConnectionsErrors, ThrowOnError> => (options.client ?? client).get<ListSsoConnectionsResponses, ListSsoConnectionsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/connections',
    ...options
});

export const getSsoJit = <ThrowOnError extends boolean = false>(options: Options<GetSsoJitData, ThrowOnError>): RequestResult<GetSsoJitResponses, GetSsoJitErrors, ThrowOnError> => (options.client ?? client).get<GetSsoJitResponses, GetSsoJitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/jit',
    ...options
});

export const postSsoSamlConnection = <ThrowOnError extends boolean = false>(options: Options<PostSsoSamlConnectionData, ThrowOnError>): RequestResult<PostSsoSamlConnectionResponses, PostSsoSamlConnectionErrors, ThrowOnError> => (options.client ?? client).post<PostSsoSamlConnectionResponses, PostSsoSamlConnectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/saml/connection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchSsoSamlConnection = <ThrowOnError extends boolean = false>(options: Options<PatchSsoSamlConnectionData, ThrowOnError>): RequestResult<PatchSsoSamlConnectionResponses, PatchSsoSamlConnectionErrors, ThrowOnError> => (options.client ?? client).patch<PatchSsoSamlConnectionResponses, PatchSsoSamlConnectionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/saml/connection/{connection_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Amends the allow-list server-side so callers never send the whole set.
 */
export const putSsoConnectionJit = <ThrowOnError extends boolean = false>(options: Options<PutSsoConnectionJitData, ThrowOnError>): RequestResult<PutSsoConnectionJitResponses, PutSsoConnectionJitErrors, ThrowOnError> => (options.client ?? client).put<PutSsoConnectionJitResponses, PutSsoConnectionJitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/sso/saml/connection/{connection_id}/jit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postTriggerSendManyRubiUsers = <ThrowOnError extends boolean = false>(options: Options<PostTriggerSendManyRubiUsersData, ThrowOnError>): RequestResult<PostTriggerSendManyRubiUsersResponses, PostTriggerSendManyRubiUsersErrors, ThrowOnError> => (options.client ?? client).post<PostTriggerSendManyRubiUsersResponses, PostTriggerSendManyRubiUsersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/trigger/send_many_rubi_users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postTriggerSendRubiOrg = <ThrowOnError extends boolean = false>(options: Options<PostTriggerSendRubiOrgData, ThrowOnError>): RequestResult<PostTriggerSendRubiOrgResponses, PostTriggerSendRubiOrgErrors, ThrowOnError> => (options.client ?? client).post<PostTriggerSendRubiOrgResponses, PostTriggerSendRubiOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/trigger/send_rubi_org',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postTriggerSendRubiUser = <ThrowOnError extends boolean = false>(options: Options<PostTriggerSendRubiUserData, ThrowOnError>): RequestResult<PostTriggerSendRubiUserResponses, PostTriggerSendRubiUserErrors, ThrowOnError> => (options.client ?? client).post<PostTriggerSendRubiUserResponses, PostTriggerSendRubiUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/trigger/send_rubi_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postUpdateManagedOnlineReportingSurveyTemplates = <ThrowOnError extends boolean = false>(options?: Options<PostUpdateManagedOnlineReportingSurveyTemplatesData, ThrowOnError>): RequestResult<PostUpdateManagedOnlineReportingSurveyTemplatesResponses, PostUpdateManagedOnlineReportingSurveyTemplatesErrors, ThrowOnError> => (options?.client ?? client).post<PostUpdateManagedOnlineReportingSurveyTemplatesResponses, PostUpdateManagedOnlineReportingSurveyTemplatesErrors, ThrowOnError>({ url: '/update_managed_online_reporting_survey_templates', ...options });

/**
 * Get current user information
 *
 * This endpoint validates the session and returns the current user's information.
 * It's used to check if the user is authenticated and get their profile data.
 */
export const getUserMe = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeData, ThrowOnError>): RequestResult<GetUserMeResponses, GetUserMeErrors, ThrowOnError> => (options?.client ?? client).get<GetUserMeResponses, GetUserMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user/me',
    ...options
});

/**
 * Update current user information
 *
 * This endpoint allows the authenticated user to update their profile information.
 * Only the current user can update their own information.
 */
export const updateUserMe = <ThrowOnError extends boolean = false>(options: Options<UpdateUserMeData, ThrowOnError>): RequestResult<UpdateUserMeResponses, UpdateUserMeErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserMeResponses, UpdateUserMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteUserKv = <ThrowOnError extends boolean = false>(options: Options<DeleteUserKvData, ThrowOnError>): RequestResult<DeleteUserKvResponses, DeleteUserKvErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserKvResponses, DeleteUserKvErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user_kv/{key}',
    ...options
});

export const putUserKv = <ThrowOnError extends boolean = false>(options: Options<PutUserKvData, ThrowOnError>): RequestResult<PutUserKvResponses, PutUserKvErrors, ThrowOnError> => (options.client ?? client).put<PutUserKvResponses, PutUserKvErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user_kv/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getUserMeRs = <ThrowOnError extends boolean = false>(options?: Options<GetUserMeRsData, ThrowOnError>): RequestResult<GetUserMeRsResponses, GetUserMeRsErrors, ThrowOnError> => (options?.client ?? client).post<GetUserMeRsResponses, GetUserMeRsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user_rs/me',
    ...options
});

export const postWebhookTwilioDeliveryStatus = <ThrowOnError extends boolean = false>(options?: Options<PostWebhookTwilioDeliveryStatusData, ThrowOnError>): RequestResult<PostWebhookTwilioDeliveryStatusResponses, PostWebhookTwilioDeliveryStatusErrors, ThrowOnError> => (options?.client ?? client).post<PostWebhookTwilioDeliveryStatusResponses, PostWebhookTwilioDeliveryStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/webhook/conversation_twilio_delivery_status',
    ...options
});

export const postWebhookTwilioInboundMessage = <ThrowOnError extends boolean = false>(options?: Options<PostWebhookTwilioInboundMessageData, ThrowOnError>): RequestResult<PostWebhookTwilioInboundMessageResponses, PostWebhookTwilioInboundMessageErrors, ThrowOnError> => (options?.client ?? client).post<PostWebhookTwilioInboundMessageResponses, PostWebhookTwilioInboundMessageErrors, ThrowOnError>({
    responseType: 'json',
    url: '/webhook/conversation_twilio_inbound_message',
    ...options
});

export const postWebhookRubiOrg = <ThrowOnError extends boolean = false>(options: Options<PostWebhookRubiOrgData, ThrowOnError>): RequestResult<PostWebhookRubiOrgResponses, PostWebhookRubiOrgErrors, ThrowOnError> => (options.client ?? client).post<PostWebhookRubiOrgResponses, PostWebhookRubiOrgErrors, ThrowOnError>({
    responseType: 'json',
    url: '/webhook/rubi_org',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postWebhookRubiUser = <ThrowOnError extends boolean = false>(options: Options<PostWebhookRubiUserData, ThrowOnError>): RequestResult<PostWebhookRubiUserResponses, PostWebhookRubiUserErrors, ThrowOnError> => (options.client ?? client).post<PostWebhookRubiUserResponses, PostWebhookRubiUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/webhook/rubi_user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
